webpackJsonp([35783957827783],{

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(4);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactDesc = __webpack_require__(126);
	
	var _reactRouter = __webpack_require__(209);
	
	var _LinkNext = __webpack_require__(97);
	
	var _LinkNext2 = _interopRequireDefault(_LinkNext);
	
	var _CSSClassnames = __webpack_require__(3);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.ANCHOR;
	
	var Anchor = function (_Component) {
	  _inherits(Anchor, _Component);
	
	  function Anchor(props, context) {
	    _classCallCheck(this, Anchor);
	
	    var _this = _possibleConstructorReturn(this, (Anchor.__proto__ || Object.getPrototypeOf(Anchor)).call(this, props, context));
	
	    _this._onClick = _this._onClick.bind(_this);
	    _this._onLocationChange = _this._onLocationChange.bind(_this);
	    _this._attachUnlisten = _this._attachUnlisten.bind(_this);
	    _this._isRouteActive = _this._isRouteActive.bind(_this);
	    var path = props.path;
	    var router = context.router;
	
	
	    var active = _this._isRouteActive(path, router);
	
	    _this.state = { active: active };
	    return _this;
	  }
	
	  _createClass(Anchor, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var path = this.props.path;
	      var router = this.context.router;
	
	
	      if (path) {
	        this._attachUnlisten(router.history || router);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var path = nextProps.path;
	      var router = this.context.router;
	
	
	      if (path && path !== this.props.path) {
	        this._attachUnlisten(router.history || router);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var path = this.props.path;
	
	      if (path) {
	        this._unlisten();
	      }
	      this._unmounted = true;
	    }
	  }, {
	    key: '_isRouteActive',
	    value: function _isRouteActive(path, router) {
	      if (!path) {
	        return false;
	      }
	      var active = void 0;
	      if (router && router.isActive) {
	        active = router && router.isActive && path && router.isActive({
	          pathname: path.path || path,
	          query: { indexLink: path.index }
	        });
	      } else if (router && _reactRouter.matchPath) {
	        active = !!(0, _reactRouter.matchPath)(router.history.location.pathname, { path: path.path || path, exact: !!path.index });
	      }
	
	      return active;
	    }
	  }, {
	    key: '_attachUnlisten',
	    value: function _attachUnlisten(router) {
	      this._unlisten = router.listen(this._onLocationChange);
	    }
	  }, {
	    key: '_onLocationChange',
	    value: function _onLocationChange(location) {
	      // sometimes react router is still calling the listen callback even
	      // if we called unlisten. So we added this check here to prevent
	      // calling setState in a unmounted component
	      if (!this._unmounted) {
	        var path = this.props.path;
	        var router = this.context.router;
	
	        var active = _reactRouter.matchPath ? !!(0, _reactRouter.matchPath)(location.pathname, { path: path.path || path, exact: !!path.index }) : router && location.pathname === (path.path || path);
	        this.setState({ active: active });
	      }
	    }
	  }, {
	    key: '_onClick',
	    value: function _onClick(event) {
	      var _props = this.props,
	          method = _props.method,
	          onClick = _props.onClick,
	          path = _props.path,
	          disabled = _props.disabled;
	      var router = this.context.router;
	
	      var modifierKey = event.ctrlKey || event.metaKey;
	
	      if (modifierKey && !disabled && !onClick) {
	        return true;
	      }
	
	      event.preventDefault();
	
	      if (!disabled) {
	        if (path) {
	          if ('push' === method) {
	            (router.history || router).push(path.path || path);
	          } else if ('replace' === method) {
	            (router.history || router).replace(path.path || path);
	          }
	        }
	
	        if (onClick) {
	          onClick.apply(undefined, arguments);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          align = _props2.align,
	          animateIcon = _props2.animateIcon,
	          children = _props2.children,
	          className = _props2.className,
	          disabled = _props2.disabled,
	          href = _props2.href,
	          icon = _props2.icon,
	          label = _props2.label,
	          onClick = _props2.onClick,
	          path = _props2.path,
	          primary = _props2.primary,
	          reverse = _props2.reverse,
	          tag = _props2.tag,
	          props = _objectWithoutProperties(_props2, ['a11yTitle', 'align', 'animateIcon', 'children', 'className', 'disabled', 'href', 'icon', 'label', 'onClick', 'path', 'primary', 'reverse', 'tag']);
	
	      delete props.method;
	      var active = this.state.active;
	      var router = this.context.router;
	
	
	      var anchorIcon = void 0;
	      if (icon) {
	        anchorIcon = icon;
	      } else if (primary) {
	        anchorIcon = _react2.default.createElement(_LinkNext2.default, { a11yTitle: 'link next' });
	      }
	
	      if (anchorIcon && !primary && !label) {
	        anchorIcon = _react2.default.createElement(
	          'span',
	          { className: CLASS_ROOT + '__icon' },
	          anchorIcon
	        );
	      }
	
	      var hasIcon = anchorIcon !== undefined;
	      var anchorChildren = _react.Children.map(children, function (child) {
	        if (child && child.type && child.type.icon) {
	          hasIcon = true;
	          child = _react2.default.createElement(
	            'span',
	            { className: CLASS_ROOT + '__icon' },
	            child
	          );
	        }
	        return child;
	      });
	
	      var target = path ? path.path || path : undefined;
	      var adjustedHref = void 0;
	      if (router && router.createPath) {
	        adjustedHref = path && router ? router.createPath(target) : href;
	      } else {
	        adjustedHref = path && router && router.history ? router.history.createHref(typeof target === 'string' ? { pathname: target } : target) : href;
	      }
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--animate-icon', hasIcon && animateIcon !== false), _defineProperty(_classnames, CLASS_ROOT + '--disabled', disabled), _defineProperty(_classnames, CLASS_ROOT + '--icon', anchorIcon || hasIcon), _defineProperty(_classnames, CLASS_ROOT + '--icon-label', hasIcon && label), _defineProperty(_classnames, CLASS_ROOT + '--align-' + align, align), _defineProperty(_classnames, CLASS_ROOT + '--primary', primary), _defineProperty(_classnames, CLASS_ROOT + '--reverse', reverse), _defineProperty(_classnames, CLASS_ROOT + '--active', active), _classnames), className);
	
	      var adjustedOnClick = path && router ? this._onClick : onClick;
	      if (!anchorChildren) {
	        anchorChildren = label;
	      }
	
	      var first = reverse ? anchorChildren : anchorIcon;
	      var second = reverse ? anchorIcon : anchorChildren;
	
	      var Component = tag;
	
	      return _react2.default.createElement(
	        Component,
	        _extends({}, props, { href: adjustedHref, className: classes,
	          'aria-label': a11yTitle, onClick: function onClick(event) {
	            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	              args[_key - 1] = arguments[_key];
	            }
	
	            if (disabled) {
	              event.preventDefault();
	            } else if (adjustedOnClick) {
	              adjustedOnClick.apply(undefined, [event].concat(args));
	            }
	          } }),
	        first,
	        second
	      );
	    }
	  }]);
	
	  return Anchor;
	}(_react.Component);
	
	Anchor.displayName = 'Anchor';
	exports.default = Anchor;
	;
	
	(0, _reactDesc.schema)(Anchor, {
	  description: 'A text link. We have a separate component from the browser\n  base so we can style it. You can either set the icon and/or label properties\n  or just use children.',
	  usage: 'import Anchor from \'grommet/components/Anchor\';\n  <Anchor href={location} label="Label" />',
	  props: {
	    a11yTitle: [_reactDesc.PropTypes.string, 'Accessibility title.'],
	    align: [_reactDesc.PropTypes.oneOf(['start', 'center', 'end']), 'Text alignment.'],
	    animateIcon: [_reactDesc.PropTypes.bool, 'Whether to animate the icon on hover.', {
	      defaultProp: true
	    }],
	    disabled: [_reactDesc.PropTypes.bool, 'Whether to disable the anchor.'],
	    href: [_reactDesc.PropTypes.string, 'Hyperlink reference to place in the anchor. If' + ' `path` prop is provided, `href` prop will be ignored.'],
	    icon: [_reactDesc.PropTypes.element, 'Icon element to place in the anchor.'],
	    id: [_reactDesc.PropTypes.string, 'Anchor identifier.'],
	    label: [_reactDesc.PropTypes.node, 'Label text to place in the anchor.'],
	    method: [_reactDesc.PropTypes.oneOf(['push', 'replace']), 'Valid only when used with path. Indicates whether the browser history' + ' should be appended to or replaced.', {
	      defaultProp: 'push'
	    }],
	    onClick: [_reactDesc.PropTypes.func, 'Click handler.'],
	    path: [_reactDesc.PropTypes.oneOfType([_reactDesc.PropTypes.object, _reactDesc.PropTypes.string]), 'React-router path to navigate to when clicked.' + ' Use path={{ path: \'/\', index: true }} if you want the Anchor to be' + ' active only when the index route is current.'],
	    primary: [_reactDesc.PropTypes.bool, 'Whether this is a primary anchor.'],
	    reverse: [_reactDesc.PropTypes.bool, 'Whether an icon and label should be reversed so that the icon is at ' + 'the end of the anchor.'],
	    tag: [_reactDesc.PropTypes.string, 'The DOM tag to use for the element. The default is <a>. This should be' + ' used in conjunction with components like Link from React Router. In' + ' this case, Link controls the navigation while Anchor controls the' + ' styling.', {
	      defaultProp: 'a'
	    }],
	    target: [_reactDesc.PropTypes.string, 'Target of the link.']
	  }
	});
	
	Anchor.contextTypes = {
	  router: _propTypes2.default.object
	};
	module.exports = exports['default'];

/***/ }),

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(9);
	
	var _KeyboardAccelerators = __webpack_require__(21);
	
	var _KeyboardAccelerators2 = _interopRequireDefault(_KeyboardAccelerators);
	
	var _Intl = __webpack_require__(5);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(6);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	var _DOM = __webpack_require__(16);
	
	var _SkipLinkAnchor = __webpack_require__(95);
	
	var _SkipLinkAnchor2 = _interopRequireDefault(_SkipLinkAnchor);
	
	var _CSSClassnames = __webpack_require__(3);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Announcer = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.BOX;
	var BACKGROUND_COLOR_INDEX = _CSSClassnames2.default.BACKGROUND_COLOR_INDEX;
	
	var Box = function (_Component) {
	  _inherits(Box, _Component);
	
	  function Box(props) {
	    _classCallCheck(this, Box);
	
	    var _this = _possibleConstructorReturn(this, (Box.__proto__ || Object.getPrototypeOf(Box)).call(this, props));
	
	    _this.state = { mouseActive: false };
	    return _this;
	  }
	
	  _createClass(Box, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var onClick = this.props.onClick;
	
	      if (onClick) {
	        var clickCallback = function clickCallback() {
	          if (_this2.boxContainerRef === document.activeElement) {
	            onClick();
	          }
	        };
	
	        _KeyboardAccelerators2.default.startListeningToKeyboard(this, {
	          enter: clickCallback,
	          space: clickCallback
	        });
	      }
	
	      this._setDarkBackground();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.colorIndex !== this.props.colorIndex) {
	        if (nextProps.colorIndex) {
	          this.setState({ updateDarkBackground: true });
	        } else {
	          this.setState({ darkBackground: undefined });
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.announce) {
	        (0, _Announcer.announce)(this.boxContainerRef.textContent);
	      }
	      if (this.state.updateDarkBackground) {
	        this.setState({ updateDarkBackground: false });
	        this._setDarkBackground();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.onClick) {
	        _KeyboardAccelerators2.default.stopListeningToKeyboard(this);
	      }
	      if (this._checkBackground) {
	        this._checkBackground.stop();
	      }
	    }
	  }, {
	    key: '_setDarkBackground',
	    value: function _setDarkBackground() {
	      var _this3 = this;
	
	      var colorIndex = this.props.colorIndex;
	
	      var box = (0, _reactDom.findDOMNode)(this.boxContainerRef);
	      if (this._checkBackground) {
	        this._checkBackground.stop();
	      }
	      this._checkBackground = (0, _DOM.checkDarkBackground)(colorIndex, box, function (darkBackground) {
	        return _this3.setState({ darkBackground: darkBackground });
	      });
	    }
	  }, {
	    key: '_normalize',
	    value: function _normalize(string) {
	      return string.replace('/', '-');
	    }
	  }, {
	    key: '_addPropertyClass',
	    value: function _addPropertyClass(classes, property) {
	      var _this4 = this;
	
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      var value = (options.object || this.props)[property];
	      var elementName = options.elementName || CLASS_ROOT;
	      var prefix = options.prefix || property;
	      if (value) {
	        if (typeof value === 'string') {
	          classes.push(elementName + '--' + prefix + '-' + this._normalize(value));
	        } else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	          Object.keys(value).forEach(function (key) {
	            _this4._addPropertyClass(classes, key, {
	              object: value, prefix: prefix + '-' + key });
	          });
	        } else {
	          classes.push(elementName + '--' + this._normalize(prefix));
	        }
	      }
	    }
	  }, {
	    key: '_backgroundContextClass',
	    value: function _backgroundContextClass(darkBackground) {
	      var result = void 0;
	      if (undefined === darkBackground) {
	        result = BACKGROUND_COLOR_INDEX + '--pending';
	      } else if (darkBackground) {
	        result = BACKGROUND_COLOR_INDEX + '--dark';
	      } else {
	        result = BACKGROUND_COLOR_INDEX + '--light';
	      }
	      return result;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _props = this.props,
	          a11yTitle = _props.a11yTitle,
	          appCentered = _props.appCentered,
	          backgroundImage = _props.backgroundImage,
	          children = _props.children,
	          className = _props.className,
	          colorIndex = _props.colorIndex,
	          containerClassName = _props.containerClassName,
	          focusable = _props.focusable,
	          full = _props.full,
	          id = _props.id,
	          onClick = _props.onClick,
	          _onBlur = _props.onBlur,
	          _onFocus = _props.onFocus,
	          _onMouseDown = _props.onMouseDown,
	          _onMouseUp = _props.onMouseUp,
	          pad = _props.pad,
	          primary = _props.primary,
	          role = _props.role,
	          size = _props.size,
	          tabIndex = _props.tabIndex,
	          tag = _props.tag,
	          texture = _props.texture;
	      var _state = this.state,
	          darkBackground = _state.darkBackground,
	          mouseActive = _state.mouseActive;
	
	      var classes = [CLASS_ROOT];
	      var containerClasses = [CLASS_ROOT + '__container'];
	      var restProps = _Props2.default.omit(this.props, Object.keys(Box.propTypes));
	      this._addPropertyClass(classes, 'full');
	      if (full && full.responsive === undefined) {
	        // default is true for backwards compatibility sake
	        classes.push(CLASS_ROOT + '--full-responsive');
	      }
	      this._addPropertyClass(classes, 'direction');
	      this._addPropertyClass(classes, 'justify');
	      this._addPropertyClass(classes, 'align');
	      this._addPropertyClass(classes, 'alignContent', { prefix: 'align-content' });
	      this._addPropertyClass(classes, 'alignSelf', { prefix: 'align-self' });
	      this._addPropertyClass(classes, 'reverse');
	      this._addPropertyClass(classes, 'responsive');
	      this._addPropertyClass(classes, 'basis');
	      this._addPropertyClass(classes, 'flex');
	      this._addPropertyClass(classes, 'pad');
	      this._addPropertyClass(classes, 'margin');
	      this._addPropertyClass(classes, 'separator');
	      this._addPropertyClass(classes, 'textAlign', { prefix: 'text-align' });
	      this._addPropertyClass(classes, 'wrap');
	
	      if (this.props.hasOwnProperty('flex')) {
	        if (!this.props.flex) {
	          classes.push(CLASS_ROOT + '--flex-off');
	        }
	      }
	      if (size) {
	        if ((typeof size === 'undefined' ? 'undefined' : _typeof(size)) === 'object') {
	          Object.keys(size).forEach(function (key) {
	            _this5._addPropertyClass(classes, key, { object: size });
	          });
	        } else {
	          this._addPropertyClass(classes, 'size');
	        }
	        if (size) {
	          if (!(size.width && size.width.max)) {
	            // don't apply 100% max-width when size using size.width.max option
	            classes.push(CLASS_ROOT + '--size');
	          }
	          if (size.width && size.width.max) {
	            // allow widths to shrink, apply 100% width
	            classes.push(CLASS_ROOT + '--width-max');
	          }
	        }
	      }
	
	      // needed to properly set flex-basis for 1/3 & 2/3 basis boxes
	      if (pad && pad.between && children) {
	        if (_react2.default.Children.count(children) % 3 === 0) {
	          classes.push(CLASS_ROOT + '--pad-between-thirds');
	        }
	      }
	
	      if (appCentered) {
	        this._addPropertyClass(containerClasses, 'full', { elementName: CLASS_ROOT + '__container' });
	        if (colorIndex) {
	          containerClasses.push(BACKGROUND_COLOR_INDEX + '-' + colorIndex);
	          containerClasses.push(this._backgroundContextClass(darkBackground));
	        }
	        if (containerClassName) {
	          containerClasses.push(containerClassName);
	        }
	      } else if (colorIndex) {
	        classes.push(BACKGROUND_COLOR_INDEX + '-' + colorIndex);
	        classes.push(this._backgroundContextClass(darkBackground));
	      }
	
	      var a11yProps = {};
	      var clickableProps = {};
	      if (onClick) {
	        classes.push(CLASS_ROOT + "--clickable");
	        clickableProps = {
	          onMouseDown: function onMouseDown(event) {
	            _this5.setState({ mouseActive: true });
	            if (_onMouseDown) {
	              _onMouseDown(event);
	            }
	          },
	          onMouseUp: function onMouseUp(event) {
	            _this5.setState({ mouseActive: false });
	            if (_onMouseUp) {
	              _onMouseUp(event);
	            }
	          },
	          onFocus: function onFocus(event) {
	            if (mouseActive === false) {
	              _this5.setState({ focus: true });
	            }
	            if (_onFocus) {
	              _onFocus(event);
	            }
	          },
	          onBlur: function onBlur(event) {
	            _this5.setState({ focus: false });
	            if (_onBlur) {
	              _onBlur(event);
	            }
	          }
	        };
	        if (focusable) {
	          if (this.state.focus) {
	            classes.push(CLASS_ROOT + '--focus');
	          }
	          var boxLabel = typeof a11yTitle !== 'undefined' ? a11yTitle : _Intl2.default.getMessage(this.context.intl, 'Box');
	          a11yProps.tabIndex = tabIndex || 0;
	          a11yProps["aria-label"] = this.props['aria-label'] || boxLabel;
	          a11yProps.role = role || 'group';
	        }
	      }
	
	      var skipLinkAnchor = void 0;
	      if (primary) {
	        var mainContentLabel = _Intl2.default.getMessage(this.context.intl, 'Main Content');
	        skipLinkAnchor = _react2.default.createElement(_SkipLinkAnchor2.default, { label: mainContentLabel });
	      }
	
	      if (className) {
	        classes.push(className);
	      }
	
	      var style = {};
	      if (texture && 'string' === typeof texture) {
	        if (texture.indexOf('url(') !== -1) {
	          style.backgroundImage = texture;
	        } else {
	          style.backgroundImage = 'url(' + texture + ')';
	        }
	      } else if (backgroundImage) {
	        style.background = backgroundImage + " no-repeat center center";
	        style.backgroundSize = "cover";
	      }
	      style = _extends({}, style, restProps.style);
	      var textureMarkup = void 0;
	      if ('object' === (typeof texture === 'undefined' ? 'undefined' : _typeof(texture))) {
	        textureMarkup = _react2.default.createElement(
	          'div',
	          { className: CLASS_ROOT + "__texture" },
	          texture
	        );
	      }
	
	      var Component = tag;
	      if (appCentered) {
	        return _react2.default.createElement(
	          'div',
	          _extends({}, restProps, { ref: function ref(_ref) {
	              return _this5.boxContainerRef = _ref;
	            },
	            className: containerClasses.join(' '),
	            style: style, role: role }, a11yProps, clickableProps),
	          skipLinkAnchor,
	          _react2.default.createElement(
	            Component,
	            { id: id, className: classes.join(' ') },
	            textureMarkup,
	            children
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          Component,
	          _extends({}, restProps, { ref: function ref(_ref2) {
	              return _this5.boxContainerRef = _ref2;
	            },
	            id: id, className: classes.join(' '), style: style,
	            role: role, tabIndex: tabIndex,
	            onClick: onClick }, a11yProps, clickableProps),
	          skipLinkAnchor,
	          textureMarkup,
	          children
	        );
	      }
	    }
	  }]);
	
	  return Box;
	}(_react.Component);
	
	Box.displayName = 'Box';
	exports.default = Box;
	
	
	var FIXED_SIZES = ['xsmall', 'small', 'medium', 'large', 'xlarge', 'xxlarge'];
	var RELATIVE_SIZES = ['full', '1/2', '1/3', '2/3', '1/4', '3/4'];
	var SIZES = FIXED_SIZES.concat(RELATIVE_SIZES);
	var MARGIN_SIZES = ['small', 'medium', 'large', 'none'];
	var PAD_SIZES = ['small', 'medium', 'large', 'xlarge', 'none'];
	
	Box.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  announce: _propTypes2.default.bool,
	  align: _propTypes2.default.oneOf(['start', 'center', 'end', 'baseline', 'stretch']),
	  alignContent: _propTypes2.default.oneOf(['start', 'center', 'end', 'between', 'around', 'stretch']),
	  alignSelf: _propTypes2.default.oneOf(['start', 'center', 'end', 'stretch']),
	  appCentered: _propTypes2.default.bool,
	  backgroundImage: _propTypes2.default.string,
	  basis: _propTypes2.default.oneOf(SIZES),
	  colorIndex: _propTypes2.default.string,
	  containerClassName: _propTypes2.default.string,
	  direction: _propTypes2.default.oneOf(['row', 'column']),
	  focusable: _propTypes2.default.bool,
	  flex: _propTypes2.default.oneOf(['grow', 'shrink', true, false]),
	  full: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string, _propTypes2.default.shape({
	    vertical: _propTypes2.default.bool,
	    horizontal: _propTypes2.default.bool,
	    responsive: _propTypes2.default.bool
	  })]),
	  // remove in 1.0?
	  onClick: _propTypes2.default.func,
	  justify: _propTypes2.default.oneOf(['start', 'center', 'between', 'end', 'around']),
	  margin: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(MARGIN_SIZES), _propTypes2.default.shape({
	    bottom: _propTypes2.default.oneOf(MARGIN_SIZES),
	    horizontal: _propTypes2.default.oneOf(MARGIN_SIZES),
	    left: _propTypes2.default.oneOf(MARGIN_SIZES),
	    right: _propTypes2.default.oneOf(MARGIN_SIZES),
	    top: _propTypes2.default.oneOf(MARGIN_SIZES),
	    vertical: _propTypes2.default.oneOf(MARGIN_SIZES)
	  })]),
	  pad: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(PAD_SIZES), _propTypes2.default.shape({
	    between: _propTypes2.default.oneOf(PAD_SIZES),
	    horizontal: _propTypes2.default.oneOf(PAD_SIZES),
	    vertical: _propTypes2.default.oneOf(PAD_SIZES)
	  })]),
	  primary: _propTypes2.default.bool,
	  reverse: _propTypes2.default.bool,
	  responsive: _propTypes2.default.bool,
	  role: _propTypes2.default.string,
	  separator: _propTypes2.default.oneOf(['top', 'bottom', 'left', 'right', 'horizontal', 'vertical', 'all', 'none']),
	  size: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['auto', 'xsmall', 'small', 'medium', 'large', 'xlarge', 'xxlarge', 'full']), // remove in 1.0?, use basis
	  _propTypes2.default.shape({
	    height: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(SIZES), _propTypes2.default.shape({
	      max: _propTypes2.default.oneOf(FIXED_SIZES),
	      min: _propTypes2.default.oneOf(FIXED_SIZES)
	    })]),
	    width: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(SIZES), _propTypes2.default.shape({
	      max: _propTypes2.default.oneOf(FIXED_SIZES),
	      min: _propTypes2.default.oneOf(FIXED_SIZES)
	    })])
	  })]),
	  tag: _propTypes2.default.string,
	  textAlign: _propTypes2.default.oneOf(['left', 'center', 'right']),
	  texture: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
	  wrap: _propTypes2.default.bool
	};
	
	Box.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Box.defaultProps = {
	  announce: false,
	  direction: 'column',
	  pad: 'none',
	  tag: 'div',
	  responsive: true,
	  focusable: true
	};
	module.exports = exports['default'];

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(4);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(3);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Box = __webpack_require__(7);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CLASS_ROOT = _CSSClassnames2.default.BUTTON;
	
	function getHoverModifier(hoverIndicator) {
	  if (hoverIndicator) {
	    if ((typeof hoverIndicator === 'undefined' ? 'undefined' : _typeof(hoverIndicator)) === 'object') {
	      if (hoverIndicator.background) {
	        if (typeof hoverIndicator.background === 'string') {
	          var prefix = _CSSClassnames.namespace + 'background-hover-color-index-';
	          return '' + prefix + hoverIndicator.background;
	        }
	        return CLASS_ROOT + '--hover-background';
	      }
	    } else if (typeof hoverIndicator === 'string') {
	      return CLASS_ROOT + '--hover-' + hoverIndicator;
	    }
	  }
	}
	
	var Button = function (_Component) {
	  _inherits(Button, _Component);
	
	  function Button() {
	    _classCallCheck(this, Button);
	
	    var _this = _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this));
	
	    _this._onClick = _this._onClick.bind(_this);
	    _this._onMouseDown = _this._onMouseDown.bind(_this);
	    _this._onMouseUp = _this._onMouseUp.bind(_this);
	    _this._onFocus = _this._onFocus.bind(_this);
	    _this._onBlur = _this._onBlur.bind(_this);
	    _this.state = {
	      mouseActive: false,
	      focus: false
	    };
	    return _this;
	  }
	
	  _createClass(Button, [{
	    key: '_onClick',
	    value: function _onClick(event) {
	      var _props = this.props,
	          method = _props.method,
	          onClick = _props.onClick,
	          path = _props.path;
	      var router = this.context.router;
	
	      var modifierKey = event.ctrlKey || event.metaKey;
	
	      if (modifierKey && !onClick) {
	        return true;
	      }
	
	      event.preventDefault();
	
	      if ('push' === method) {
	        (router.history || router).push(path);
	      } else if ('replace' === method) {
	        (router.history || router).replace(path);
	      }
	
	      if (onClick) {
	        onClick.apply(undefined, arguments);
	      }
	    }
	  }, {
	    key: '_onMouseDown',
	    value: function _onMouseDown(event) {
	      var onMouseDown = this.props.onMouseDown;
	
	      this.setState({ mouseActive: true });
	      if (onMouseDown) {
	        onMouseDown(event);
	      }
	    }
	  }, {
	    key: '_onMouseUp',
	    value: function _onMouseUp(event) {
	      var onMouseUp = this.props.onMouseUp;
	
	      this.setState({ mouseActive: false });
	      if (onMouseUp) {
	        onMouseUp(event);
	      }
	    }
	  }, {
	    key: '_onFocus',
	    value: function _onFocus(event) {
	      var onFocus = this.props.onFocus;
	      var mouseActive = this.state.mouseActive;
	
	      if (mouseActive === false) {
	        this.setState({ focus: true });
	      }
	      if (onFocus) {
	        onFocus(event);
	      }
	    }
	  }, {
	    key: '_onBlur',
	    value: function _onBlur(event) {
	      var onBlur = this.props.onBlur;
	
	      this.setState({ focus: false });
	      if (onBlur) {
	        onBlur(event);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          accent = _props2.accent,
	          align = _props2.align,
	          box = _props2.box,
	          children = _props2.children,
	          className = _props2.className,
	          critical = _props2.critical,
	          fill = _props2.fill,
	          hoverIndicator = _props2.hoverIndicator,
	          href = _props2.href,
	          icon = _props2.icon,
	          label = _props2.label,
	          onClick = _props2.onClick,
	          path = _props2.path,
	          plain = _props2.plain,
	          primary = _props2.primary,
	          reverse = _props2.reverse,
	          secondary = _props2.secondary,
	          type = _props2.type,
	          props = _objectWithoutProperties(_props2, ['a11yTitle', 'accent', 'align', 'box', 'children', 'className', 'critical', 'fill', 'hoverIndicator', 'href', 'icon', 'label', 'onClick', 'path', 'plain', 'primary', 'reverse', 'secondary', 'type']);
	
	      delete props.method;
	      var router = this.context.router;
	
	
	      var buttonIcon = void 0;
	      if (icon) {
	        buttonIcon = _react2.default.createElement(
	          'span',
	          { className: CLASS_ROOT + '__icon' },
	          icon
	        );
	      }
	
	      var buttonLabel = void 0;
	      if (label) {
	        buttonLabel = _react2.default.createElement(
	          'span',
	          { className: CLASS_ROOT + '__label' },
	          label
	        );
	      }
	
	      var adjustedHref = void 0;
	      if (router && router.createPath) {
	        adjustedHref = path && router ? router.createPath(path) : href;
	      } else {
	        adjustedHref = path && router && router.history ? router.history.createHref({ pathname: path }) : href;
	      }
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--box', box), _defineProperty(_classnames, CLASS_ROOT + '--critical', critical), _defineProperty(_classnames, CLASS_ROOT + '--focus', this.state.focus), _defineProperty(_classnames, CLASS_ROOT + '--primary', primary), _defineProperty(_classnames, CLASS_ROOT + '--secondary', secondary), _defineProperty(_classnames, CLASS_ROOT + '--accent', accent), _defineProperty(_classnames, CLASS_ROOT + '--disabled', !onClick && !adjustedHref && ['reset', 'submit'].indexOf(type) === -1), _defineProperty(_classnames, CLASS_ROOT + '--fill', fill), _defineProperty(_classnames, CLASS_ROOT + '--plain', plain || box || _react.Children.count(children) > 0 || icon && !label), _defineProperty(_classnames, CLASS_ROOT + '--align-' + align, align), _defineProperty(_classnames, getHoverModifier(hoverIndicator), hoverIndicator), _classnames), className);
	
	      var adjustedOnClick = path && router ? this._onClick : onClick;
	
	      var Tag = adjustedHref ? 'a' : 'button';
	      var buttonType = void 0;
	      if (!adjustedHref) {
	        buttonType = type;
	      }
	
	      var boxProps = void 0;
	      if (box) {
	        // Let the root element of the Button be a Box element with tag prop
	        boxProps = {
	          tag: Tag
	        };
	        Tag = _Box2.default;
	      }
	
	      var first = reverse ? buttonLabel : buttonIcon;
	      var second = reverse ? buttonIcon : buttonLabel;
	
	      return _react2.default.createElement(
	        Tag,
	        _extends({}, props, boxProps, { href: adjustedHref, type: buttonType,
	          className: classes, 'aria-label': a11yTitle,
	          onClick: adjustedOnClick,
	          disabled: !onClick && !adjustedHref && ['reset', 'submit'].indexOf(type) === -1,
	          onMouseDown: this._onMouseDown, onMouseUp: this._onMouseUp,
	          onFocus: this._onFocus, onBlur: this._onBlur }),
	        first,
	        second,
	        children
	      );
	    }
	  }]);
	
	  return Button;
	}(_react.Component);
	
	Button.displayName = 'Button';
	exports.default = Button;
	
	
	Button.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  accent: _propTypes2.default.bool,
	  align: _propTypes2.default.oneOf(['start', 'center', 'end']),
	  box: _propTypes2.default.bool,
	  critical: _propTypes2.default.bool,
	  fill: _propTypes2.default.bool,
	  hoverIndicator: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['background']), _propTypes2.default.shape({
	    background: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string])
	  })]),
	  href: _propTypes2.default.string,
	  icon: _propTypes2.default.element,
	  label: _propTypes2.default.node,
	  method: _propTypes2.default.oneOf(['push', 'replace']),
	  onClick: _propTypes2.default.func,
	  path: _propTypes2.default.string,
	  plain: _propTypes2.default.bool,
	  primary: _propTypes2.default.bool,
	  reverse: _propTypes2.default.bool,
	  secondary: _propTypes2.default.bool,
	  type: _propTypes2.default.oneOf(['button', 'reset', 'submit'])
	};
	
	Button.defaultProps = {
	  method: 'push',
	  type: 'button'
	};
	
	Button.contextTypes = {
	  router: _propTypes2.default.object
	};
	module.exports = exports['default'];

/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames3 = __webpack_require__(4);
	
	var _classnames4 = _interopRequireDefault(_classnames3);
	
	var _CSSClassnames = __webpack_require__(3);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Props = __webpack_require__(6);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	var _Box = __webpack_require__(7);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _Label = __webpack_require__(334);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _Heading = __webpack_require__(41);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _Headline = __webpack_require__(333);
	
	var _Headline2 = _interopRequireDefault(_Headline);
	
	var _Paragraph = __webpack_require__(159);
	
	var _Paragraph2 = _interopRequireDefault(_Paragraph);
	
	var _Anchor = __webpack_require__(57);
	
	var _Anchor2 = _interopRequireDefault(_Anchor);
	
	var _Layer = __webpack_require__(94);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Video = __webpack_require__(339);
	
	var _Video2 = _interopRequireDefault(_Video);
	
	var _CirclePlay = __webpack_require__(160);
	
	var _CirclePlay2 = _interopRequireDefault(_CirclePlay);
	
	var _Responsive = __webpack_require__(107);
	
	var _Responsive2 = _interopRequireDefault(_Responsive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CARD;
	
	var LABEL_SIZES = {
	  xlarge: 'medium',
	  large: 'medium',
	  medium: 'medium',
	  small: 'medium',
	  xsmall: 'small'
	};
	
	var HEADLINE_SIZES = {
	  xlarge: 'medium',
	  large: 'medium'
	};
	
	var HEADING_TAGS = {
	  medium: 'h1',
	  small: 'h2',
	  xsmall: 'h3'
	};
	
	var PARAGRAPH_SIZES = {
	  xlarge: 'xlarge',
	  large: 'xlarge',
	  medium: 'large',
	  small: 'large',
	  xsmall: 'medium'
	};
	
	var PARAGRAPH_MARGINS = {
	  xlarge: 'large',
	  large: 'large',
	  medium: 'medium',
	  small: 'medium',
	  xsmall: 'small'
	};
	
	var Card = function (_Component) {
	  _inherits(Card, _Component);
	
	  function Card(props) {
	    _classCallCheck(this, Card);
	
	    var _this = _possibleConstructorReturn(this, (Card.__proto__ || Object.getPrototypeOf(Card)).call(this, props));
	
	    _this._onClick = _this._onClick.bind(_this);
	    _this._onResponsive = _this._onResponsive.bind(_this);
	    _this.state = { activeVideo: false, small: false };
	    return _this;
	  }
	
	  _createClass(Card, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._responsive = _Responsive2.default.start(this._onResponsive);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._responsive) {
	        this._responsive.stop();
	      }
	    }
	  }, {
	    key: '_onResponsive',
	    value: function _onResponsive(small) {
	      this.setState({ small: !!small });
	    }
	  }, {
	    key: '_onClick',
	    value: function _onClick(event) {
	      var video = this.props.video;
	
	      if (video) {
	        event.preventDefault();
	        this.setState({ activeVideo: !this.state.activeVideo });
	      }
	    }
	  }, {
	    key: '_renderLabel',
	    value: function _renderLabel() {
	      var _props = this.props,
	          label = _props.label,
	          textSize = _props.textSize;
	
	      var result = label;
	      if (typeof label === 'string') {
	        result = _react2.default.createElement(
	          _Label2.default,
	          { size: LABEL_SIZES[textSize], margin: 'none', uppercase: true },
	          label
	        );
	      }
	      return result;
	    }
	  }, {
	    key: '_renderHeading',
	    value: function _renderHeading() {
	      var _props2 = this.props,
	          heading = _props2.heading,
	          headingStrong = _props2.headingStrong,
	          textSize = _props2.textSize;
	
	      var result = heading;
	      if (typeof heading === 'string') {
	        if (HEADLINE_SIZES[textSize]) {
	          result = _react2.default.createElement(
	            _Headline2.default,
	            { size: HEADLINE_SIZES[textSize], strong: headingStrong },
	            heading
	          );
	        } else {
	          result = _react2.default.createElement(
	            _Heading2.default,
	            { tag: HEADING_TAGS[textSize], strong: headingStrong },
	            heading
	          );
	        }
	      }
	      return result;
	    }
	  }, {
	    key: '_renderLink',
	    value: function _renderLink() {
	      var link = this.props.link;
	
	      return link;
	    }
	  }, {
	    key: '_renderThumbnail',
	    value: function _renderThumbnail() {
	      var _props3 = this.props,
	          direction = _props3.direction,
	          thumbnail = _props3.thumbnail,
	          video = _props3.video;
	      var small = this.state.small;
	
	      var result = thumbnail;
	      if (typeof thumbnail === 'string') {
	        var size = small ? 'large' : 'xlarge';
	        var videoIcon = video ? _react2.default.createElement(_Anchor2.default, { icon: _react2.default.createElement(_CirclePlay2.default, { responsive: false,
	            colorIndex: 'brand', size: size }) }) : undefined;
	
	        var flex = 'row' === direction ? 'grow' : undefined;
	
	        result = _react2.default.createElement(
	          _Box2.default,
	          { className: CLASS_ROOT + '__thumbnail', flex: flex,
	            backgroundImage: 'url(' + thumbnail + ')', basis: 'small',
	            justify: 'center', align: 'center' },
	          videoIcon
	        );
	      }
	      return result;
	    }
	  }, {
	    key: '_renderVideoLayer',
	    value: function _renderVideoLayer() {
	      var video = this.props.video;
	      var activeVideo = this.state.activeVideo;
	
	      var result = void 0;
	
	      if (video && activeVideo) {
	        var layerContent = void 0;
	        if (video.source) {
	          layerContent = _react2.default.createElement(
	            _Video2.default,
	            null,
	            _react2.default.createElement('source', { src: video.source, type: 'video/' + video.type })
	          );
	        } else {
	          layerContent = video;
	        }
	
	        result = _react2.default.createElement(
	          _Layer2.default,
	          { onClose: this._onClick, closer: true, flush: true },
	          layerContent
	        );
	      }
	
	      return result;
	    }
	  }, {
	    key: '_renderDescription',
	    value: function _renderDescription() {
	      var _props4 = this.props,
	          description = _props4.description,
	          textSize = _props4.textSize;
	
	      var result = description;
	      if (typeof description === 'string') {
	        result = _react2.default.createElement(
	          _Paragraph2.default,
	          {
	            margin: PARAGRAPH_MARGINS[textSize],
	            size: PARAGRAPH_SIZES[textSize]
	          },
	          description
	        );
	      }
	      return result;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames2;
	
	      var _props5 = this.props,
	          a11yTitle = _props5.a11yTitle,
	          children = _props5.children,
	          className = _props5.className,
	          contentPad = _props5.contentPad,
	          onClick = _props5.onClick,
	          reverse = _props5.reverse,
	          truncate = _props5.truncate;
	
	      var boxProps = _Props2.default.pick(this.props, Object.keys(_Box2.default.propTypes));
	      var restProps = _Props2.default.omit(this.props, Object.keys(Card.propTypes));
	
	      var classes = (0, _classnames4.default)(CLASS_ROOT, _defineProperty({}, CLASS_ROOT + '--selectable', onClick), className);
	
	      var thumbnail = this._renderThumbnail();
	      var label = this._renderLabel();
	      var heading = this._renderHeading();
	      var description = this._renderDescription();
	      var link = this._renderLink();
	      var videoLayer = this._renderVideoLayer();
	
	      var contentClasses = (0, _classnames4.default)((_classnames2 = {}, _defineProperty(_classnames2, CLASS_ROOT + '__content', true), _defineProperty(_classnames2, CLASS_ROOT + '__content--truncate', truncate), _classnames2));
	
	      var basis = 'row' === this.props.direction ? '2/3' : undefined;
	      var text = _react2.default.createElement(
	        _Box2.default,
	        { className: contentClasses, pad: contentPad,
	          basis: basis },
	        label,
	        heading,
	        description,
	        children,
	        link
	      );
	
	      var cardJustify = void 0;
	      if (reverse) {
	        // align thumbnail to bottom/right of card for bottom cardPlacement
	        cardJustify = 'between';
	      }
	
	      if (!this.props.size) {
	        if (this.props.direction === 'row') {
	          boxProps.size = { width: 'xlarge' };
	        } else {
	          boxProps.size = { width: 'medium' };
	        }
	      }
	
	      return _react2.default.createElement(
	        _Box2.default,
	        _extends({}, boxProps, restProps, { className: classes, wrap: true,
	          justify: cardJustify, onClick: onClick, a11yTitle: a11yTitle }),
	        thumbnail,
	        text,
	        videoLayer
	      );
	    }
	  }]);
	
	  return Card;
	}(_react.Component);
	
	Card.displayName = 'Card';
	exports.default = Card;
	
	
	Card.propTypes = _extends({
	  contentPad: _Box2.default.propTypes.pad,
	  description: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  heading: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  headingStrong: _propTypes2.default.bool,
	  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  link: _propTypes2.default.element,
	  textSize: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge']),
	  thumbnail: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  truncate: _propTypes2.default.bool,
	  video: _propTypes2.default.oneOfType([_propTypes2.default.shape({
	    source: _propTypes2.default.string.isRequired,
	    type: _propTypes2.default.string
	  }), _propTypes2.default.element])
	}, _Box2.default.propTypes);
	
	Card.defaultProps = {
	  a11yTitle: 'Card',
	  contentPad: 'medium',
	  headingStrong: true,
	  textSize: 'small'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 329:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(4);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(3);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.FORM;
	
	var Form = function (_Component) {
	  _inherits(Form, _Component);
	
	  function Form() {
	    _classCallCheck(this, Form);
	
	    return _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).apply(this, arguments));
	  }
	
	  _createClass(Form, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          compact = _props.compact,
	          fill = _props.fill,
	          pad = _props.pad,
	          plain = _props.plain,
	          props = _objectWithoutProperties(_props, ['className', 'compact', 'fill', 'pad', 'plain']);
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--compact', compact), _defineProperty(_classnames, CLASS_ROOT + '--fill', fill), _defineProperty(_classnames, CLASS_ROOT + '--pad-' + pad, typeof pad === 'string'), _defineProperty(_classnames, CLASS_ROOT + '--pad-horizontal-' + pad.horizontal, (typeof pad === 'undefined' ? 'undefined' : _typeof(pad)) === 'object' && 'horizontal' in pad), _defineProperty(_classnames, CLASS_ROOT + '--pad-vertical-' + pad.vertical, (typeof pad === 'undefined' ? 'undefined' : _typeof(pad)) === 'object' && 'vertical' in pad), _defineProperty(_classnames, CLASS_ROOT + '--plain', plain), _classnames), className);
	
	      return _react2.default.createElement(
	        'form',
	        _extends({}, props, { className: classes, onSubmit: this.props.onSubmit }),
	        this.props.children
	      );
	    }
	  }]);
	
	  return Form;
	}(_react.Component);
	
	Form.displayName = 'Form';
	exports.default = Form;
	
	
	Form.propTypes = {
	  compact: _propTypes2.default.bool,
	  fill: _propTypes2.default.bool,
	  onSubmit: _propTypes2.default.func,
	  pad: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['none', 'small', 'medium', 'large']), _propTypes2.default.shape({
	    horizontal: _propTypes2.default.oneOf(['none', 'small', 'medium', 'large']),
	    vertical: _propTypes2.default.oneOf(['none', 'small', 'medium', 'large'])
	  })]),
	  plain: _propTypes2.default.bool
	};
	
	Form.defaultProps = {
	  compact: false,
	  fill: false,
	  pad: 'none'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(4);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(3);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.FORM_FIELD;
	
	var FormField = function (_Component) {
	  _inherits(FormField, _Component);
	
	  function FormField(props, context) {
	    _classCallCheck(this, FormField);
	
	    var _this = _possibleConstructorReturn(this, (FormField.__proto__ || Object.getPrototypeOf(FormField)).call(this, props, context));
	
	    _this._onFocus = _this._onFocus.bind(_this);
	    _this._onBlur = _this._onBlur.bind(_this);
	    _this._onClick = _this._onClick.bind(_this);
	
	    _this.state = { focus: false };
	    return _this;
	  }
	
	  _createClass(FormField, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var contentsElement = this.contentsRef;
	      if (contentsElement) {
	        var inputElements = contentsElement.querySelectorAll('input, textarea, select');
	        if (inputElements.length === 1) {
	          this._inputElement = inputElements[0];
	          this._inputElement.addEventListener('focus', this._onFocus);
	          this._inputElement.addEventListener('blur', this._onBlur);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._inputElement) {
	        this._inputElement.removeEventListener('focus', this._onFocus);
	        this._inputElement.removeEventListener('blur', this._onBlur);
	        delete this._inputElement;
	      }
	    }
	  }, {
	    key: '_onFocus',
	    value: function _onFocus() {
	      this.setState({ focus: true });
	    }
	  }, {
	    key: '_onBlur',
	    value: function _onBlur() {
	      this.setState({ focus: false });
	    }
	  }, {
	    key: '_onClick',
	    value: function _onClick() {
	      if (this._inputElement) {
	        this._inputElement.focus();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames,
	          _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          help = _props.help,
	          hidden = _props.hidden,
	          htmlFor = _props.htmlFor,
	          label = _props.label,
	          size = _props.size,
	          strong = _props.strong,
	          error = _props.error,
	          props = _objectWithoutProperties(_props, ['children', 'className', 'help', 'hidden', 'htmlFor', 'label', 'size', 'strong', 'error']);
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--focus', this.state.focus), _defineProperty(_classnames, CLASS_ROOT + '--hidden', hidden), _defineProperty(_classnames, CLASS_ROOT + '--text', htmlFor), _defineProperty(_classnames, CLASS_ROOT + '--size-' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--strong', strong), _defineProperty(_classnames, CLASS_ROOT + '--error', error), _classnames), className);
	
	      var fieldError = error ? _react2.default.createElement(
	        'span',
	        { className: CLASS_ROOT + "__error" },
	        error
	      ) : undefined;
	
	      var fieldHelp = help !== null && help !== undefined ? _react2.default.createElement(
	        'span',
	        { className: CLASS_ROOT + "__help" },
	        this.props.help
	      ) : undefined;
	
	      var labelNode = label ? _react2.default.createElement(
	        'label',
	        { className: CLASS_ROOT + "__label", htmlFor: htmlFor },
	        label
	      ) : undefined;
	
	      return _react2.default.createElement(
	        'div',
	        _extends({ className: classes }, props, { onClick: this._onClick }),
	        fieldError,
	        labelNode,
	        fieldHelp,
	        _react2.default.createElement(
	          'span',
	          { ref: function ref(_ref) {
	              return _this2.contentsRef = _ref;
	            },
	            className: CLASS_ROOT + "__contents" },
	          children
	        )
	      );
	    }
	  }]);
	
	  return FormField;
	}(_react.Component);
	
	FormField.displayName = 'FormField';
	exports.default = FormField;
	
	
	FormField.propTypes = {
	  error: _propTypes2.default.node,
	  help: _propTypes2.default.node,
	  hidden: _propTypes2.default.bool,
	  htmlFor: _propTypes2.default.string,
	  label: _propTypes2.default.node,
	  size: _propTypes2.default.oneOf(['medium', 'large']),
	  strong: _propTypes2.default.bool
	};
	
	FormField.defaultProps = {
	  size: 'medium',
	  strong: false
	};
	module.exports = exports['default'];

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(4);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(3);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.HEADING;
	
	var Heading = function (_Component) {
	  _inherits(Heading, _Component);
	
	  function Heading() {
	    _classCallCheck(this, Heading);
	
	    return _possibleConstructorReturn(this, (Heading.__proto__ || Object.getPrototypeOf(Heading)).apply(this, arguments));
	  }
	
	  _createClass(Heading, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          align = _props.align,
	          children = _props.children,
	          className = _props.className,
	          margin = _props.margin,
	          size = _props.size,
	          strong = _props.strong,
	          Tag = _props.tag,
	          truncate = _props.truncate,
	          uppercase = _props.uppercase,
	          props = _objectWithoutProperties(_props, ['align', 'children', 'className', 'margin', 'size', 'strong', 'tag', 'truncate', 'uppercase']);
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--strong', strong), _defineProperty(_classnames, CLASS_ROOT + '--align-' + align, align), _defineProperty(_classnames, CLASS_ROOT + '--margin-' + margin, margin), _defineProperty(_classnames, CLASS_ROOT + '--truncate', truncate), _defineProperty(_classnames, CLASS_ROOT + '--uppercase', uppercase), _classnames), className);
	
	      return _react2.default.createElement(
	        Tag,
	        _extends({}, props, { className: classes }),
	        children
	      );
	    }
	  }]);
	
	  return Heading;
	}(_react.Component);
	
	Heading.displayName = 'Heading';
	exports.default = Heading;
	
	
	Heading.propTypes = {
	  align: _propTypes2.default.oneOf(['start', 'center', 'end']),
	  margin: _propTypes2.default.oneOf(['none', 'small', 'medium', 'large']),
	  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
	  strong: _propTypes2.default.bool,
	  tag: _propTypes2.default.string,
	  truncate: _propTypes2.default.bool,
	  uppercase: _propTypes2.default.bool
	};
	
	Heading.defaultProps = {
	  tag: 'h1'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 333:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(4);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(3);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.HEADLINE;
	
	var Headline = function (_Component) {
	  _inherits(Headline, _Component);
	
	  function Headline() {
	    _classCallCheck(this, Headline);
	
	    return _possibleConstructorReturn(this, (Headline.__proto__ || Object.getPrototypeOf(Headline)).apply(this, arguments));
	  }
	
	  _createClass(Headline, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          align = _props.align,
	          children = _props.children,
	          className = _props.className,
	          margin = _props.margin,
	          size = _props.size,
	          strong = _props.strong,
	          props = _objectWithoutProperties(_props, ['align', 'children', 'className', 'margin', 'size', 'strong']);
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--align-' + align, align), _defineProperty(_classnames, CLASS_ROOT + '--margin-' + margin, margin), _defineProperty(_classnames, CLASS_ROOT + '--strong', strong), _classnames), className);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, props, { className: classes }),
	        children
	      );
	    }
	  }]);
	
	  return Headline;
	}(_react.Component);
	
	Headline.displayName = 'Headline';
	exports.default = Headline;
	
	
	Headline.propTypes = {
	  align: _propTypes2.default.oneOf(['start', 'center', 'end']),
	  margin: _propTypes2.default.oneOf(['none', 'small', 'medium', 'large']),
	  size: _propTypes2.default.oneOf(['small', 'medium', 'large', 'xlarge']),
	  strong: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),

/***/ 334:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(4);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(3);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Announcer = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.LABEL;
	
	var Label = function (_Component) {
	  _inherits(Label, _Component);
	
	  function Label() {
	    _classCallCheck(this, Label);
	
	    return _possibleConstructorReturn(this, (Label.__proto__ || Object.getPrototypeOf(Label)).apply(this, arguments));
	  }
	
	  _createClass(Label, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.announce) {
	        (0, _Announcer.announce)(this.labelRef.textContent);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames,
	          _this2 = this;
	
	      var _props = this.props,
	          align = _props.align,
	          children = _props.children,
	          className = _props.className,
	          labelFor = _props.labelFor,
	          margin = _props.margin,
	          size = _props.size,
	          truncate = _props.truncate,
	          uppercase = _props.uppercase,
	          props = _objectWithoutProperties(_props, ['align', 'children', 'className', 'labelFor', 'margin', 'size', 'truncate', 'uppercase']);
	
	      delete props.announce;
	      var labelMargin = margin ? margin : 'small' === size ? 'none' : 'medium';
	      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--truncate', truncate), _defineProperty(_classnames, CLASS_ROOT + '--uppercase', uppercase), _defineProperty(_classnames, CLASS_ROOT + '--margin-' + labelMargin, labelMargin), _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--align-' + align, align), _classnames), className);
	
	      return _react2.default.createElement(
	        'label',
	        _extends({ ref: function ref(_ref) {
	            return _this2.labelRef = _ref;
	          } }, props, {
	          className: classes, htmlFor: labelFor }),
	        children
	      );
	    }
	  }]);
	
	  return Label;
	}(_react.Component);
	
	Label.displayName = 'Label';
	exports.default = Label;
	
	
	Label.propTypes = {
	  align: _propTypes2.default.oneOf(['start', 'center', 'end']),
	  announce: _propTypes2.default.bool,
	  labelFor: _propTypes2.default.string,
	  margin: _propTypes2.default.oneOf(['none', 'small', 'medium', 'large']),
	  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
	  truncate: _propTypes2.default.bool,
	  uppercase: _propTypes2.default.bool
	};
	
	Label.defaultProps = {
	  size: 'medium'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(9);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames2 = __webpack_require__(4);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _Button = __webpack_require__(25);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Close = __webpack_require__(96);
	
	var _Close2 = _interopRequireDefault(_Close);
	
	var _CSSClassnames = __webpack_require__(3);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _DOM = __webpack_require__(16);
	
	var _Intl = __webpack_require__(5);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _KeyboardAccelerators = __webpack_require__(21);
	
	var _KeyboardAccelerators2 = _interopRequireDefault(_KeyboardAccelerators);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.LAYER;
	var APP = _CSSClassnames2.default.APP;
	
	var LayerContents = function (_Component) {
	  _inherits(LayerContents, _Component);
	
	  function LayerContents(props, context) {
	    _classCallCheck(this, LayerContents);
	
	    var _this = _possibleConstructorReturn(this, (LayerContents.__proto__ || Object.getPrototypeOf(LayerContents)).call(this, props, context));
	
	    _this._processTab = _this._processTab.bind(_this);
	
	    _this.state = {
	      dropActive: false
	    };
	    return _this;
	  }
	
	  _createClass(LayerContents, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var _this2 = this;
	
	      return {
	        history: this.props.history,
	        intl: this.props.intl,
	        onDropChange: function onDropChange(active) {
	          _this2.setState({ dropActive: active });
	        },
	        router: this.props.router,
	        store: this.props.store
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          hidden = _props.hidden,
	          onClose = _props.onClose;
	
	
	      if (!hidden) {
	        this.anchorStepRef.focus();
	        this.anchorStepRef.scrollIntoView();
	      }
	
	      this._keyboardHandlers = {
	        tab: this._processTab
	      };
	      if (onClose) {
	        this._keyboardHandlers.esc = onClose;
	      }
	      _KeyboardAccelerators2.default.startListeningToKeyboard(this, this._keyboardHandlers);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var hidden = this.props.hidden;
	
	      if (hidden) {
	        _KeyboardAccelerators2.default.stopListeningToKeyboard(this, this._keyboardHandlers);
	      };
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _KeyboardAccelerators2.default.stopListeningToKeyboard(this, this._keyboardHandlers);
	    }
	  }, {
	    key: '_processTab',
	    value: function _processTab(event) {
	      var hidden = this.props.hidden;
	
	      if (hidden) {
	        return;
	      }
	      var items = this.containerRef.getElementsByTagName('*');
	      items = (0, _DOM.filterByFocusable)(items);
	
	      if (!items || items.length === 0) {
	        event.preventDefault();
	      } else {
	        if (event.shiftKey) {
	          if (event.target === items[0]) {
	            items[items.length - 1].focus();
	            event.preventDefault();
	          }
	        } else if (event.target === items[items.length - 1]) {
	          items[0].focus();
	          event.preventDefault();
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          children = _props2.children,
	          closer = _props2.closer,
	          onClose = _props2.onClose;
	      var intl = this.context.intl;
	
	
	      var closerNode = void 0;
	      if ((typeof closer === 'undefined' ? 'undefined' : _typeof(closer)) === 'object') {
	        closerNode = closer;
	      } else if (onClose && closer) {
	        var closeLabel = _Intl2.default.getMessage(intl, 'Close');
	        var layerLabel = _Intl2.default.getMessage(intl, 'Layer');
	        var closeIconTitle = closeLabel + ' ' + (a11yTitle || '') + ' ' + layerLabel;
	
	        closerNode = _react2.default.createElement(
	          'div',
	          { className: CLASS_ROOT + '__closer' },
	          _react2.default.createElement(_Button2.default, { plain: true, icon: _react2.default.createElement(_Close2.default, {
	              a11yTitle: closeIconTitle }),
	            onClick: onClose })
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { ref: function ref(_ref2) {
	            return _this3.containerRef = _ref2;
	          },
	          className: CLASS_ROOT + '__container' },
	        _react2.default.createElement('a', { tabIndex: '-1', 'aria-hidden': 'true', style: { outline: 'none' },
	          ref: function ref(_ref) {
	            return _this3.anchorStepRef = _ref;
	          } }),
	        closerNode,
	        children
	      );
	    }
	  }]);
	
	  return LayerContents;
	}(_react.Component);
	
	LayerContents.displayName = 'LayerContents';
	
	
	LayerContents.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  closer: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.bool]),
	  history: _propTypes2.default.object,
	  intl: _propTypes2.default.object,
	  onClose: _propTypes2.default.func,
	  router: _propTypes2.default.any,
	  store: _propTypes2.default.any
	};
	
	// Because Layer creates a new DOM render context, the context
	// is not transfered. For now, we hard code these specific ones.
	// TODO: Either figure out how to introspect the context and transfer
	// whatever we find or have callers explicitly indicate which parts
	// of the context to transfer somehow.
	LayerContents.childContextTypes = {
	  history: _propTypes2.default.object,
	  intl: _propTypes2.default.object,
	  onDropChange: _propTypes2.default.func,
	  router: _propTypes2.default.any,
	  store: _propTypes2.default.object
	};
	
	var Layer = function (_Component2) {
	  _inherits(Layer, _Component2);
	
	  function Layer() {
	    _classCallCheck(this, Layer);
	
	    return _possibleConstructorReturn(this, (Layer.__proto__ || Object.getPrototypeOf(Layer)).apply(this, arguments));
	  }
	
	  _createClass(Layer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._originalFocusedElement = document.activeElement;
	      this._originalScrollPosition = {
	        top: window.pageYOffset,
	        left: window.pageXOffset
	      };
	      this._addLayer();
	      this._renderLayer();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this._renderLayer();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _this5 = this;
	
	      var hidden = this.props.hidden;
	
	      if (this._originalFocusedElement && !hidden) {
	        if (this._originalFocusedElement.focus) {
	          // wait for the fixed positioning to come back to normal
	          // see layer styling for reference
	          setTimeout(function () {
	            _this5._originalFocusedElement.focus();
	            window.scrollTo(_this5._originalScrollPosition.left, _this5._originalScrollPosition.top);
	          }, 0);
	        } else if (this._originalFocusedElement.parentNode && this._originalFocusedElement.parentNode.focus) {
	          // required for IE11 and Edge
	          this._originalFocusedElement.parentNode.focus();
	          window.scrollTo(this._originalScrollPosition.left, this._originalScrollPosition.top);
	        }
	      }
	
	      this._removeLayer();
	    }
	  }, {
	    key: '_classesFromProps',
	    value: function _classesFromProps() {
	      var _classnames;
	
	      var _props3 = this.props,
	          align = _props3.align,
	          className = _props3.className,
	          closer = _props3.closer,
	          flush = _props3.flush,
	          hidden = _props3.hidden,
	          peek = _props3.peek;
	
	
	      return (0, _classnames3.default)('grommet', CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--align-' + this.props.align, align), _defineProperty(_classnames, CLASS_ROOT + '--closeable', closer), _defineProperty(_classnames, CLASS_ROOT + '--flush', flush), _defineProperty(_classnames, CLASS_ROOT + '--hidden', hidden), _defineProperty(_classnames, CLASS_ROOT + '--peek', peek), _classnames), className);
	    }
	  }, {
	    key: '_addLayer',
	    value: function _addLayer() {
	      var id = this.props.id;
	
	
	      var element = document.createElement('div');
	      if (id) {
	        element.id = id;
	      }
	      element.className = this._classesFromProps();
	      // insert before .app, if possible.
	      var appElements = document.querySelectorAll('.' + APP);
	      var beforeElement;
	      if (appElements.length > 0) {
	        beforeElement = appElements[0];
	      } else {
	        beforeElement = document.body.firstChild;
	      }
	      if (beforeElement) {
	        this._element = beforeElement.parentNode.insertBefore(element, beforeElement);
	      }
	    }
	  }, {
	    key: '_handleAriaHidden',
	    value: function _handleAriaHidden(hideOverlay) {
	      var _this6 = this;
	
	      setTimeout(function () {
	        var ariaHidden = hideOverlay || false;
	        var grommetApps = document.querySelectorAll('.' + APP);
	        var visibleLayers = document.querySelectorAll('.' + CLASS_ROOT + ':not(.' + CLASS_ROOT + '--hidden)');
	
	        if (grommetApps) {
	          Array.prototype.slice.call(grommetApps).forEach(function (grommetApp) {
	            if (ariaHidden && visibleLayers.length === 0) {
	              // make sure to only show grommet apps if there is no other layer
	              grommetApp.setAttribute('aria-hidden', false);
	              grommetApp.classList.remove(APP + '--hidden');
	              // scroll body content to the original position
	              grommetApp.style.top = '-' + _this6._originalScrollPosition.top + 'px';
	              grommetApp.style.left = '-' + _this6._originalScrollPosition.left + 'px';
	            } else {
	              grommetApp.setAttribute('aria-hidden', true);
	              grommetApp.classList.add(APP + '--hidden');
	              // this must be null to work
	              grommetApp.style.top = null;
	              grommetApp.style.left = null;
	            }
	          }, _this6);
	        }
	      }, 0);
	    }
	  }, {
	    key: '_renderLayer',
	    value: function _renderLayer() {
	      var _this7 = this;
	
	      if (this._element) {
	        this._element.className = this._classesFromProps();
	        var contents = _react2.default.createElement(LayerContents, _extends({}, this.props, {
	          history: this.context.history,
	          intl: this.context.intl,
	          router: this.context.router,
	          store: this.context.store }));
	        _reactDom2.default.render(contents, this._element, function () {
	          var hidden = _this7.props.hidden;
	
	          if (hidden) {
	            _this7._handleAriaHidden(true);
	          } else {
	            _this7._handleAriaHidden(false);
	          }
	        });
	      }
	    }
	  }, {
	    key: '_removeLayer',
	    value: function _removeLayer() {
	      this._element.removeEventListener('animationend', this._onAnimationEnd);
	
	      _reactDom2.default.unmountComponentAtNode(this._element);
	      this._element.parentNode.removeChild(this._element);
	      this._element = undefined;
	
	      // make sure to handle aria attributes after the layer is removed
	      this._handleAriaHidden(true);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('span', { style: { display: 'none' } });
	    }
	  }]);
	
	  return Layer;
	}(_react.Component);
	
	Layer.displayName = 'Layer';
	exports.default = Layer;
	
	
	Layer.propTypes = {
	  align: _propTypes2.default.oneOf(['center', 'top', 'bottom', 'left', 'right']),
	  closer: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.bool]),
	  flush: _propTypes2.default.bool,
	  hidden: _propTypes2.default.bool,
	  peek: _propTypes2.default.bool,
	  onClose: _propTypes2.default.func
	};
	
	Layer.contextTypes = {
	  router: _propTypes2.default.any,
	  history: _propTypes2.default.object,
	  intl: _propTypes2.default.object,
	  store: _propTypes2.default.object
	};
	
	Layer.defaultProps = {
	  align: 'center'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(4);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(3);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.PARAGRAPH;
	
	var Paragraph = function (_Component) {
	  _inherits(Paragraph, _Component);
	
	  function Paragraph() {
	    _classCallCheck(this, Paragraph);
	
	    return _possibleConstructorReturn(this, (Paragraph.__proto__ || Object.getPrototypeOf(Paragraph)).apply(this, arguments));
	  }
	
	  _createClass(Paragraph, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          align = _props.align,
	          children = _props.children,
	          className = _props.className,
	          margin = _props.margin,
	          size = _props.size,
	          width = _props.width,
	          props = _objectWithoutProperties(_props, ['align', 'children', 'className', 'margin', 'size', 'width']);
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--align-' + align, align), _defineProperty(_classnames, CLASS_ROOT + '--margin-' + margin, margin), _defineProperty(_classnames, CLASS_ROOT + '--width-' + width, width), _classnames), className);
	
	      return _react2.default.createElement(
	        'p',
	        _extends({}, props, { className: classes }),
	        children
	      );
	    }
	  }]);
	
	  return Paragraph;
	}(_react.Component);
	
	Paragraph.displayName = 'Paragraph';
	exports.default = Paragraph;
	
	
	Paragraph.propTypes = {
	  align: _propTypes2.default.oneOf(['start', 'center', 'end']),
	  margin: _propTypes2.default.oneOf(['none', 'small', 'medium', 'large']),
	  size: _propTypes2.default.oneOf(['small', 'medium', 'large', 'xlarge']),
	  width: _propTypes2.default.oneOf(['small', 'medium', 'large'])
	};
	module.exports = exports['default'];

/***/ }),

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Box = __webpack_require__(7);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _CSSClassnames = __webpack_require__(3);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.SECTION;
	
	var Section = function (_Component) {
	  _inherits(Section, _Component);
	
	  function Section() {
	    _classCallCheck(this, Section);
	
	    return _possibleConstructorReturn(this, (Section.__proto__ || Object.getPrototypeOf(Section)).apply(this, arguments));
	  }
	
	  _createClass(Section, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          props = _objectWithoutProperties(_props, ['className']);
	
	      var classes = (0, _classnames2.default)(CLASS_ROOT, className);
	
	      return _react2.default.createElement(_Box2.default, _extends({}, props, { tag: 'section', className: classes }));
	    }
	  }]);
	
	  return Section;
	}(_react.Component);
	
	Section.displayName = 'Section';
	exports.default = Section;
	;
	
	Section.propTypes = _extends({}, _Box2.default.propTypes);
	
	Section.defaultProps = {
	  pad: { vertical: 'medium' }
	};
	module.exports = exports['default'];

/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CSSClassnames = __webpack_require__(3);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.SKIP_LINK_ANCHOR;
	
	var SkipLinkAnchor = function (_Component) {
	  _inherits(SkipLinkAnchor, _Component);
	
	  function SkipLinkAnchor() {
	    _classCallCheck(this, SkipLinkAnchor);
	
	    return _possibleConstructorReturn(this, (SkipLinkAnchor.__proto__ || Object.getPrototypeOf(SkipLinkAnchor)).apply(this, arguments));
	  }
	
	  _createClass(SkipLinkAnchor, [{
	    key: 'render',
	    value: function render() {
	      var id = 'skip-link-' + this.props.label.toLowerCase().replace(/ /g, '_');
	
	      return _react2.default.createElement(
	        'a',
	        { tabIndex: '-1', 'aria-hidden': 'true', id: id, className: CLASS_ROOT },
	        this.props.label
	      );
	    }
	  }]);
	
	  return SkipLinkAnchor;
	}(_react.Component);
	
	SkipLinkAnchor.displayName = 'SkipLinkAnchor';
	exports.default = SkipLinkAnchor;
	
	
	SkipLinkAnchor.propTypes = {
	  label: _propTypes2.default.node.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Anchor = __webpack_require__(57);
	
	var _Anchor2 = _interopRequireDefault(_Anchor);
	
	var _SocialTwitter = __webpack_require__(350);
	
	var _SocialTwitter2 = _interopRequireDefault(_SocialTwitter);
	
	var _SocialFacebook = __webpack_require__(346);
	
	var _SocialFacebook2 = _interopRequireDefault(_SocialFacebook);
	
	var _SocialGooglePlus = __webpack_require__(347);
	
	var _SocialGooglePlus2 = _interopRequireDefault(_SocialGooglePlus);
	
	var _SocialLinkedin = __webpack_require__(348);
	
	var _SocialLinkedin2 = _interopRequireDefault(_SocialLinkedin);
	
	var _SocialMail = __webpack_require__(349);
	
	var _SocialMail2 = _interopRequireDefault(_SocialMail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var SocialShare = function (_Component) {
	  _inherits(SocialShare, _Component);
	
	  function SocialShare() {
	    _classCallCheck(this, SocialShare);
	
	    return _possibleConstructorReturn(this, (SocialShare.__proto__ || Object.getPrototypeOf(SocialShare)).apply(this, arguments));
	  }
	
	  _createClass(SocialShare, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex,
	          type = _props.type,
	          link = _props.link,
	          text = _props.text,
	          title = _props.title,
	          a11yTitle = _props.a11yTitle,
	          props = _objectWithoutProperties(_props, ['className', 'colorIndex', 'type', 'link', 'text', 'title', 'a11yTitle']);
	
	      var socialIcon = undefined;
	      var href = '';
	      var target = '_blank';
	      var calculatedA11yTitle = a11yTitle || 'Share on ' + (type.charAt(0).toUpperCase() + type.slice(1));
	
	      var encodedLink = encodeURIComponent(link);
	      var encodedTitle = encodeURIComponent(title);
	      var encodedText = encodeURIComponent(text);
	
	      if (type === 'twitter') {
	        socialIcon = _react2.default.createElement(_SocialTwitter2.default, {
	          a11yTitle: calculatedA11yTitle,
	          className: className, colorIndex: colorIndex });
	        href = 'https://twitter.com/intent/tweet?url=' + (encodedLink + '&text=' + encodedText);
	      } else if (type === 'linkedin') {
	        socialIcon = _react2.default.createElement(_SocialLinkedin2.default, {
	          a11yTitle: calculatedA11yTitle,
	          className: className, colorIndex: colorIndex });
	        href = 'https://www.linkedin.com/shareArticle?mini=true&url=' + (encodedLink + '&title=' + encodedTitle + '&summary=' + encodedText);
	      } else if (type === 'google') {
	        socialIcon = _react2.default.createElement(_SocialGooglePlus2.default, {
	          a11yTitle: calculatedA11yTitle,
	          className: className, colorIndex: colorIndex });
	        href = 'https://plus.google.com/share?url=' + encodedLink;
	      } else if (type === 'facebook') {
	        socialIcon = _react2.default.createElement(_SocialFacebook2.default, {
	          a11yTitle: calculatedA11yTitle,
	          className: className, colorIndex: colorIndex });
	        href = 'https://www.facebook.com/sharer/sharer.php?u=' + encodedLink;
	      } else if (type === 'email') {
	        socialIcon = _react2.default.createElement(_SocialMail2.default, {
	          a11yTitle: calculatedA11yTitle,
	          className: className, colorIndex: colorIndex });
	        href = 'mailto:?subject=' + (encodedTitle + '&body=' + encodedText + '%0D%0A' + encodedLink);
	        target = '_self';
	      }
	
	      return _react2.default.createElement(_Anchor2.default, _extends({}, props, { href: href, icon: socialIcon, target: target }));
	    }
	  }]);
	
	  return SocialShare;
	}(_react.Component);
	
	SocialShare.displayName = 'SocialShare';
	exports.default = SocialShare;
	
	
	SocialShare.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  link: _propTypes2.default.string.isRequired,
	  text: _propTypes2.default.string,
	  title: _propTypes2.default.string,
	  type: _propTypes2.default.oneOf(['email', 'facebook', 'twitter', 'linkedin', 'google']).isRequired
	};
	
	SocialShare.defaultProps = {
	  text: '',
	  title: ''
	};
	module.exports = exports['default'];

/***/ }),

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(9);
	
	var _classnames2 = __webpack_require__(4);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(3);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Props = __webpack_require__(6);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	var _Controls = __webpack_require__(353);
	
	var _Controls2 = _interopRequireDefault(_Controls);
	
	var _Overlay = __webpack_require__(355);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _Throttle = __webpack_require__(363);
	
	var _Throttle2 = _interopRequireDefault(_Throttle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.VIDEO;
	var BACKGROUND_COLOR_INDEX = _CSSClassnames2.default.BACKGROUND_COLOR_INDEX;
	
	var Video = function (_Component) {
	  _inherits(Video, _Component);
	
	  function Video(props, context) {
	    _classCallCheck(this, Video);
	
	    var _this = _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).call(this, props, context));
	
	    _this._hasPlayed = false;
	    _this._play = _this._play.bind(_this);
	    _this._pause = _this._pause.bind(_this);
	    _this._togglePlay = _this._togglePlay.bind(_this);
	    _this._toggleMute = _this._toggleMute.bind(_this);
	    _this._seek = _this._seek.bind(_this);
	    _this._mute = _this._mute.bind(_this);
	    _this._unmute = _this._unmute.bind(_this);
	    _this._fullscreen = _this._fullscreen.bind(_this);
	    _this._onInterationStart = _this._onInterationStart.bind(_this);
	    _this._onInteractionOver = _this._onInteractionOver.bind(_this);
	    _this._renderControls = _this._renderControls.bind(_this);
	
	    _this.state = {
	      mouseActive: false
	    };
	    return _this;
	  }
	
	  _createClass(Video, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this._update = (0, _Throttle2.default)(this._update.bind(this), 100, this);
	      this._mediaEventProps = this._injectUpdateVideoEvents();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // Dynamically modifying a source element and its attribute when
	      // the element is already inserted in a video or audio element will
	      // have no effect.
	      // From HTML Specs:
	      // https://html.spec.whatwg.org/multipage/embedded-content.html
	      //   #the-source-element
	      // Using forceUpdate to force redraw of video when receiving new <source>
	      this.forceUpdate();
	    }
	  }, {
	    key: '_injectUpdateVideoEvents',
	    value: function _injectUpdateVideoEvents() {
	      var _this2 = this;
	
	      var videoEvents = ['onAbort', 'onCanPlay', 'onCanPlayThrough', 'onDurationChange', 'onEmptied', 'onEncrypted', 'onEnded', 'onError', 'onLoadedData', 'onLoadedMetadata', 'onLoadStart', 'onPause', 'onPlay', 'onPlaying', 'onProgress', 'onRateChange', 'onSeeked', 'onSeeking', 'onStalled', 'onSuspend', 'onTimeUpdate', 'onVolumeChange', 'onWaiting'];
	
	      return videoEvents.reduce(function (previousValue, currentValue) {
	        previousValue[currentValue] = function () {
	          if (currentValue in _this2.props && typeof _this2.props[currentValue] === 'function') {
	            _this2.props[currentValue]();
	          }
	          _this2._update();
	        };
	
	        return previousValue;
	      }, {});
	    }
	  }, {
	    key: '_update',
	    value: function _update() {
	      // Set flag for Video first play
	      if (!this._hasPlayed && !this._video.paused && !this._video.loading) {
	        this._hasPlayed = true;
	      }
	
	      var interacting = this.state.interacting;
	      if (this._video.ended) {
	        interacting = false;
	      };
	
	      this.setState({
	        duration: this._video.duration,
	        currentTime: this._video.currentTime,
	        buffered: this._video.buffered,
	        paused: this._video.paused,
	        muted: this._video.muted,
	        volume: this._video.volume,
	        ended: this._video.ended,
	        readyState: this._video.readyState,
	        interacting: interacting,
	        // computed values
	        hasPlayed: this._hasPlayed,
	        playing: !this._video.paused && !this._video.loading,
	        percentageBuffered: this._video.buffered.length && this._video.buffered.end(this._video.buffered.length - 1) / this._video.duration * 100,
	        percentagePlayed: this._video.currentTime / this._video.duration * 100,
	        loading: this._video.readyState < this._video.HAVE_ENOUGH_DATA
	      });
	    }
	  }, {
	    key: '_play',
	    value: function _play() {
	      this._video.play();
	    }
	  }, {
	    key: '_pause',
	    value: function _pause() {
	      this._video.pause();
	    }
	  }, {
	    key: '_togglePlay',
	    value: function _togglePlay() {
	      if (this.state.paused) {
	        this._play();
	      } else {
	        this._pause();
	      }
	    }
	  }, {
	    key: '_seek',
	    value: function _seek(time) {
	      this._video.currentTime = typeof time !== 'undefined' ? time : this._video.currentTime;
	    }
	  }, {
	    key: '_unmute',
	    value: function _unmute() {
	      this._video.muted = false;
	    }
	  }, {
	    key: '_mute',
	    value: function _mute() {
	      this._video.muted = true;
	    }
	  }, {
	    key: '_toggleMute',
	    value: function _toggleMute() {
	      if (!this.state.muted) {
	        this._mute();
	      } else {
	        this._unmute();
	      }
	    }
	  }, {
	    key: '_fullscreen',
	    value: function _fullscreen() {
	      if (this._video.requestFullscreen) {
	        this._video.requestFullscreen();
	      } else if (this._video.msRequestFullscreen) {
	        this._video.msRequestFullscreen();
	      } else if (this._video.mozRequestFullScreen) {
	        this._video.mozRequestFullScreen();
	      } else if (this._video.webkitRequestFullscreen) {
	        this._video.webkitRequestFullscreen();
	      } else {
	        console.warn('Your browser doesn\'t support fullscreen.');
	      }
	    }
	  }, {
	    key: '_onInterationStart',
	    value: function _onInterationStart() {
	      this.setState({ interacting: true });
	    }
	  }, {
	    key: '_onInteractionOver',
	    value: function _onInteractionOver() {
	      var focus = this.state.focus;
	
	      if (!focus) {
	        this.setState({ interacting: false });
	      }
	    }
	  }, {
	    key: '_renderControls',
	    value: function _renderControls() {
	      var _this3 = this;
	
	      var extendedProps = _extends({
	        title: this.props.title,
	        togglePlay: this._togglePlay,
	        toggleMute: this._toggleMute,
	        play: this._play,
	        pause: this._pause,
	        mute: this._mute,
	        unmute: this._unmute,
	        seek: this._seek,
	        timeline: this.props.timeline,
	        fullscreen: this._fullscreen,
	        shareLink: this.props.shareLink,
	        shareHeadline: this.props.shareHeadline,
	        shareText: this.props.shareText,
	        allowFullScreen: this.props.allowFullScreen,
	        size: this.props.size
	      }, this.state);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Overlay2.default, extendedProps),
	        _react2.default.createElement(_Controls2.default, _extends({ ref: function ref(_ref) {
	            return _this3._controlRef = _ref;
	          }
	        }, extendedProps))
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames,
	          _this4 = this;
	
	      var _props = this.props,
	          align = _props.align,
	          autoPlay = _props.autoPlay,
	          className = _props.className,
	          colorIndex = _props.colorIndex,
	          fit = _props.fit,
	          full = _props.full,
	          loop = _props.loop,
	          muted = _props.muted,
	          poster = _props.poster,
	          showControls = _props.showControls,
	          size = _props.size;
	      var _state = this.state,
	          ended = _state.ended,
	          hasPlayed = _state.hasPlayed,
	          interacting = _state.interacting,
	          mouseActive = _state.mouseActive,
	          playing = _state.playing;
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--' + fit, fit), _defineProperty(_classnames, CLASS_ROOT + '--full', fit || full), _defineProperty(_classnames, CLASS_ROOT + '--interacting', interacting), _defineProperty(_classnames, CLASS_ROOT + '--playing', playing), _defineProperty(_classnames, CLASS_ROOT + '--hasPlayed', hasPlayed), _defineProperty(_classnames, CLASS_ROOT + '--ended', ended), _defineProperty(_classnames, BACKGROUND_COLOR_INDEX + '--' + colorIndex, colorIndex), _defineProperty(_classnames, CLASS_ROOT + '--align-top', align && align.top), _defineProperty(_classnames, CLASS_ROOT + '--align-bottom', align && align.bottom), _defineProperty(_classnames, CLASS_ROOT + '--align-left', align && align.left), _defineProperty(_classnames, CLASS_ROOT + '--align-right', align && align.right), _classnames), className);
	      var restProps = _Props2.default.omit(this.props, Object.keys(Video.propTypes));
	
	      return _react2.default.createElement(
	        'div',
	        { className: classes, ref: function ref(_ref2) {
	            return _this4._containerRef = _ref2;
	          },
	          onMouseEnter: function onMouseEnter() {
	            if (!ended) {
	              _this4._onInterationStart();
	            }
	          },
	          onMouseMove: function onMouseMove(event) {
	            // needed to avoid react synthatic event pooling
	            event.persist();
	            if (!ended || (0, _reactDom.findDOMNode)(_this4._controlRef).contains(event.target)) {
	              _this4._onInterationStart();
	            } else if (ended) {
	              _this4._onInteractionOver();
	            }
	            clearTimeout(_this4._moveTimer);
	            _this4._moveTimer = setTimeout(function () {
	              var element = (0, _reactDom.findDOMNode)(_this4._controlRef);
	              if (element && !element.contains(event.target)) {
	                _this4._onInteractionOver();
	              }
	            }, 1000);
	          },
	          onMouseLeave: this._onInteractionOver,
	          onMouseDown: function onMouseDown() {
	            _this4.setState({ mouseActive: true });
	          },
	          onMouseUp: function onMouseUp() {
	            _this4.setState({ mouseActive: false });
	          },
	          onFocus: function onFocus() {
	            if (mouseActive === false) {
	              _this4._onInterationStart();
	              _this4.setState({ focus: true });
	            }
	          },
	          onBlur: function onBlur() {
	            _this4.setState({ focus: false }, function () {
	              if (!_this4._containerRef.contains(document.activeElement)) {
	                _this4._onInteractionOver();
	              }
	            });
	          } },
	        _react2.default.createElement(
	          'video',
	          _extends({ ref: function ref(el) {
	              return _this4._video = el;
	            } }, restProps, {
	            poster: poster, autoPlay: autoPlay ? 'autoplay' : false,
	            loop: loop ? 'loop' : false, muted: muted }, this._mediaEventProps),
	          this.props.children
	        ),
	        showControls ? this._renderControls() : undefined
	      );
	    }
	  }]);
	
	  return Video;
	}(_react.Component);
	
	Video.displayName = 'Video';
	exports.default = Video;
	
	
	Video.propTypes = {
	  align: _propTypes2.default.shape({
	    bottom: _propTypes2.default.boolean,
	    left: _propTypes2.default.boolean,
	    right: _propTypes2.default.boolean,
	    top: _propTypes2.default.boolean
	  }),
	  allowFullScreen: _propTypes2.default.bool,
	  autoPlay: _propTypes2.default.bool,
	  colorIndex: _propTypes2.default.string,
	  fit: _propTypes2.default.oneOf(['contain', 'cover']),
	  full: _propTypes2.default.oneOf([true, 'horizontal', 'vertical', false]),
	  loop: _propTypes2.default.bool,
	  muted: _propTypes2.default.bool,
	  poster: _propTypes2.default.string,
	  shareLink: _propTypes2.default.string,
	  shareHeadline: _propTypes2.default.string,
	  shareText: _propTypes2.default.string,
	  showControls: _propTypes2.default.bool,
	  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
	  timeline: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    label: _propTypes2.default.string,
	    time: _propTypes2.default.number
	  })),
	  title: _propTypes2.default.node
	};
	
	Video.defaultProps = {
	  allowFullScreen: true,
	  autoPlay: false,
	  loop: false,
	  muted: false,
	  size: 'medium',
	  showControls: true
	};
	module.exports = exports['default'];

/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(4);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(3);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(5);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(6);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-circle-play', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'circle-play');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M9.5,15.5 L15.5,12 L9.5,8.5 L9.5,15.5 Z M10.5,13.5 L12.5,12 L10.5,10.5 L10.5,13.5 Z' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'CirclePlay';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(4);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(3);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(5);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(6);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-close', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'close');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M3,3 L21,21 M3,21 L21,3' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'Close';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(4);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(3);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(5);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(6);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-expand', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'expand');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M10,14 L2,22 M1,15 L1,23 L9,23 M22,2 L14,10 M15,1 L23,1 L23,9' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'Expand';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(4);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(3);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(5);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(6);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-link-next', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'link-next');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2,12 L22,12 M13,3 L22,12 L13,21' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'LinkNext';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(4);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(3);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(5);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(6);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-pause', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'pause');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M3,21 L9,21 L9,3 L3,3 L3,21 Z M15,21 L21,21 L21,3 L15,3 L15,21 Z' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'Pause';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(4);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(3);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(5);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(6);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-play', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'play');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('polygon', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '3 22 21 12 3 2' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'Play';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),

/***/ 345:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(4);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(3);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(5);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(6);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-refresh', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'refresh');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M20,8 C18.5974037,5.04031171 15.536972,3 12,3 C7.02943725,3 3,7.02943725 3,12 C3,16.9705627 7.02943725,21 12,21 L12,21 C16.9705627,21 21,16.9705627 21,12 M21,3 L21,9 L15,9' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'Refresh';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),

/***/ 346:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(4);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(3);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(5);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(6);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-social-facebook', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'social-facebook');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('path', { fill: '#3B5998', fillRule: 'evenodd', d: 'M23.00025,0 L1.0005,0 C0.44775,0 0,0.44775 0,0.99975 L0,23.00025 C0,23.55225 0.44775,24 1.0005,24 L12.75,24 L12.75,15 L9.75,15 L9.75,11.25 L12.75,11.25 L12.75,8.25 C12.75,5.15025 14.71275,3.62475 17.478,3.62475 C18.8025,3.62475 19.941,3.72375 20.2725,3.76725 L20.2725,7.00725 L18.35475,7.008 C16.851,7.008 16.5,7.72275 16.5,8.77125 L16.5,11.25 L20.25,11.25 L19.5,15 L16.5,15 L16.56,24 L23.00025,24 C23.55225,24 24,23.55225 24,23.00025 L24,0.99975 C24,0.44775 23.55225,0 23.00025,0', stroke: 'none' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'SocialFacebook';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),

/***/ 347:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(4);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(3);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(5);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(6);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-social-google-plus', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'social-google-plus');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('path', { fill: '#4285F4', fillRule: 'evenodd', d: 'M0.0202537528,11.2032618 C0.0858884305,7.29693926 3.69605513,3.87603603 7.62298049,4.00635861 C9.5045944,3.91939087 11.2733582,4.73384249 12.7144674,5.87784249 C12.0993693,6.57306829 11.4624794,7.24274571 10.7820061,7.86906829 C9.04956189,6.67810055 6.58579693,6.33771345 4.85335275,7.71345539 C2.37505996,9.41848765 2.26220982,13.4442941 4.64607169,15.2796489 C6.96429889,17.3722941 11.3459973,16.3333264 11.9865191,13.1291973 C10.534514,13.1075199 9.07861756,13.1291973 7.62661245,13.0822296 C7.62298049,12.2205522 7.61934853,11.3588747 7.62298049,10.4974554 C10.0504259,10.4902296 12.4778712,10.4863586 14.9089486,10.5046812 C15.0544863,12.532036 14.7852026,14.6897135 13.5332146,16.3658425 C11.6370729,19.0195199 7.83052098,19.7942296 4.86061667,18.6574554 C1.88007591,17.527907 -0.230870232,14.3962941 0.0202537528,11.2032618 M19.6437253,8.32145539 L21.8091508,8.32145539 C21.8127827,9.04197152 21.8164147,9.76610055 21.8236786,10.4863586 C22.5479949,10.4938425 23.2759431,10.4938425 24,10.5010683 L24,12.6551328 C23.2759431,12.6623586 22.5516269,12.6659715 21.8236786,12.6731973 C21.8164147,13.3970683 21.8127827,14.1175844 21.8091508,14.8381005 L19.6400933,14.8381005 C19.6328294,14.1175844 19.6328294,13.3970683 19.6255655,12.6768102 C18.9012492,12.6695844 18.1735604,12.6623586 17.4492441,12.6551328 L17.4492441,10.5010683 C18.1735604,10.4938425 18.8976172,10.4902296 19.6255655,10.4863586 C19.6291974,9.76248765 19.6364613,9.04197152 19.6437253,8.32145539', stroke: 'none' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'SocialGooglePlus';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),

/***/ 348:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(4);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(3);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(5);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(6);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-social-linkedin', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'social-linkedin');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('path', { fill: '#0077B5', fillRule: 'evenodd', d: 'M20.45175,20.45025 L16.89225,20.45025 L16.89225,14.88075 C16.89225,13.5525 16.86975,11.844 15.04275,11.844 C13.191,11.844 12.90825,13.2915 12.90825,14.7855 L12.90825,20.45025 L9.3525,20.45025 L9.3525,8.997 L12.765,8.997 L12.765,10.563 L12.81375,10.563 C13.2885,9.66225 14.4495,8.71275 16.18125,8.71275 C19.78575,8.71275 20.45175,11.08425 20.45175,14.169 L20.45175,20.45025 Z M5.33925,7.4325 C4.1955,7.4325 3.27375,6.50775 3.27375,5.36775 C3.27375,4.2285 4.1955,3.30375 5.33925,3.30375 C6.47775,3.30375 7.4025,4.2285 7.4025,5.36775 C7.4025,6.50775 6.47775,7.4325 5.33925,7.4325 L5.33925,7.4325 Z M7.11975,20.45025 L3.5565,20.45025 L3.5565,8.997 L7.11975,8.997 L7.11975,20.45025 Z M23.00025,0 L1.0005,0 C0.44775,0 0,0.44775 0,0.99975 L0,22.9995 C0,23.55225 0.44775,24 1.0005,24 L23.00025,24 C23.55225,24 24,23.55225 24,22.9995 L24,0.99975 C24,0.44775 23.55225,0 23.00025,0 L23.00025,0 Z', stroke: 'none' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'SocialLinkedin';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),

/***/ 349:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(4);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(3);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(5);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(6);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-social-mail', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'social-mail');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('path', { fillRule: 'evenodd', d: 'M23,20 L23,6 L12,15 L1,6 L1,20 L23,20 Z M12,12 L22,4 L2,4 L12,12 Z' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'SocialMail';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(4);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(3);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(5);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(6);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-social-twitter', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'social-twitter');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('path', { fill: '#1DA1F2', fillRule: 'evenodd', d: 'M24,4.3086 C23.117,4.7006 22.168,4.9646 21.172,5.0836 C22.188,4.4746 22.969,3.5096 23.337,2.3596 C22.386,2.9246 21.332,3.3336 20.21,3.5556 C19.312,2.5976 18.032,1.9996 16.616,1.9996 C13.897,1.9996 11.692,4.2046 11.692,6.9236 C11.692,7.3096 11.736,7.6856 11.82,8.0456 C7.728,7.8406 4.099,5.8806 1.671,2.9006 C1.247,3.6286 1.004,4.4736 1.004,5.3766 C1.004,7.0846 1.873,8.5926 3.195,9.4756 C2.388,9.4486 1.628,9.2276 0.964,8.8596 L0.964,8.9206 C0.964,11.3066 2.661,13.2966 4.914,13.7486 C4.501,13.8626 4.065,13.9216 3.617,13.9216 C3.299,13.9216 2.991,13.8906 2.69,13.8336 C3.317,15.7896 5.135,17.2136 7.29,17.2536 C5.604,18.5736 3.481,19.3606 1.175,19.3606 C0.777,19.3606 0.385,19.3376 0,19.2926 C2.179,20.6886 4.767,21.5046 7.548,21.5046 C16.605,21.5046 21.557,14.0016 21.557,7.4946 C21.557,7.2816 21.552,7.0696 21.543,6.8586 C22.505,6.1636 23.34,5.2966 24,4.3086', stroke: 'none' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'SocialTwitter';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),

/***/ 351:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(4);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(3);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(5);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(6);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-volume', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'volume');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M15,16 C17.209,16 19,14.209 19,12 C19,9.791 17.209,8 15,8 M15,20 C20,20 23,16.411 23,12 C23,7.589 19.411,4 15,4 M1,12 L1,8 L6,8 L12,3 L12,21 L6,16 L1,16 L1,12' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'Volume';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(4);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__(3);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(5);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__(6);
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-volume-mute', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'volume-mute');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,8 L1,16 L6.09901951,16 L12,21 L12,3 L6,8 L1,8 Z M15,9 L21,15 M21,9 L15,15' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'VolumeMute';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),

/***/ 353:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(4);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _Button = __webpack_require__(25);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Box = __webpack_require__(7);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _Heading = __webpack_require__(41);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _Volume = __webpack_require__(351);
	
	var _Volume2 = _interopRequireDefault(_Volume);
	
	var _VolumeMute = __webpack_require__(352);
	
	var _VolumeMute2 = _interopRequireDefault(_VolumeMute);
	
	var _Time = __webpack_require__(358);
	
	var _Time2 = _interopRequireDefault(_Time);
	
	var _FullscreenButton = __webpack_require__(354);
	
	var _FullscreenButton2 = _interopRequireDefault(_FullscreenButton);
	
	var _ProgressBar = __webpack_require__(356);
	
	var _ProgressBar2 = _interopRequireDefault(_ProgressBar);
	
	var _PlayButton = __webpack_require__(161);
	
	var _PlayButton2 = _interopRequireDefault(_PlayButton);
	
	var _CSSClassnames = __webpack_require__(3);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__(5);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _FormatTime = __webpack_require__(174);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.VIDEO;
	var BUTTON_CLASS = CLASS_ROOT + '__button';
	
	var Controls = function (_Component) {
	  _inherits(Controls, _Component);
	
	  function Controls() {
	    _classCallCheck(this, Controls);
	
	    var _this = _possibleConstructorReturn(this, (Controls.__proto__ || Object.getPrototypeOf(Controls)).call(this));
	
	    _this._onChapterTickHover = _this._onChapterTickHover.bind(_this);
	
	    _this.state = {
	      activeChapterIndex: undefined
	    };
	    return _this;
	  }
	
	  _createClass(Controls, [{
	    key: '_onChapterTickHover',
	    value: function _onChapterTickHover(index) {
	      this.setState({ activeChapterIndex: index });
	    }
	  }, {
	    key: '_renderTitle',
	    value: function _renderTitle() {
	      var title = void 0;
	      if (this.props.title) {
	        title = _react2.default.createElement(
	          _Box2.default,
	          { pad: { horizontal: 'small', vertical: 'none' } },
	          _react2.default.createElement(
	            _Heading2.default,
	            { tag: 'h3', margin: 'none' },
	            this.props.title
	          )
	        );
	      }
	
	      return title;
	    }
	  }, {
	    key: '_renderMuteButton',
	    value: function _renderMuteButton() {
	      var _props = this.props,
	          muted = _props.muted,
	          toggleMute = _props.toggleMute;
	      var intl = this.context.intl;
	
	      var buttonMessage = _Intl2.default.getMessage(intl, 'Mute');
	      var Icon = _VolumeMute2.default;
	      if (muted) {
	        Icon = _Volume2.default;
	        buttonMessage = _Intl2.default.getMessage(intl, 'Unmute');
	      }
	      return _react2.default.createElement(
	        _Button2.default,
	        { plain: true, onClick: toggleMute, className: BUTTON_CLASS,
	          a11yTitle: buttonMessage },
	        _react2.default.createElement(Icon, { className: BUTTON_CLASS + '__icon', colorIndex: 'brand' })
	      );
	    }
	  }, {
	    key: '_renderChapterLabels',
	    value: function _renderChapterLabels() {
	      var _props2 = this.props,
	          duration = _props2.duration,
	          timeline = _props2.timeline,
	          props = _objectWithoutProperties(_props2, ['duration', 'timeline']);
	
	      var activeChapterIndex = this.state.activeChapterIndex;
	
	
	      if (timeline) {
	        var chapterLabels = timeline.map(function (chapter, index, chapters) {
	          var _classnames;
	
	          var percent = chapter.time / duration * 100;
	          var classes = (0, _classnames3.default)(CLASS_ROOT + '__chapter-label', (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '__chapter-label-start', percent === 0), _defineProperty(_classnames, CLASS_ROOT + '__chapter-label-active', activeChapterIndex === index), _classnames));
	
	          return _react2.default.createElement(
	            'div',
	            { className: classes, key: chapter.label,
	              style: { left: percent + '%' } },
	            _react2.default.createElement(
	              'span',
	              null,
	              chapter.label
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              (0, _FormatTime.formatTime)(chapter.time)
	            )
	          );
	        });
	
	        return _react2.default.createElement(
	          _Box2.default,
	          _extends({}, props, { pad: 'none', className: CLASS_ROOT + '__chapter-labels',
	            direction: 'row' }),
	          chapterLabels
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          togglePlay = _props3.togglePlay,
	          hasPlayed = _props3.hasPlayed,
	          playing = _props3.playing,
	          ended = _props3.ended,
	          currentTime = _props3.currentTime,
	          duration = _props3.duration,
	          percentagePlayed = _props3.percentagePlayed,
	          seek = _props3.seek,
	          timeline = _props3.timeline,
	          allowFullScreen = _props3.allowFullScreen,
	          fullscreen = _props3.fullscreen;
	
	
	      if (!hasPlayed) {
	        return null;
	      }
	
	      var overlayContent = _react2.default.createElement(
	        _Box2.default,
	        { pad: 'none', className: CLASS_ROOT + '__controls',
	          direction: 'column', justify: 'start' },
	        _react2.default.createElement(_ProgressBar2.default, { progress: percentagePlayed,
	          onChapterHover: this._onChapterTickHover,
	          duration: duration, onChange: seek, timeline: timeline }),
	        timeline ? this._renderChapterLabels() : undefined,
	        _react2.default.createElement(
	          _Box2.default,
	          { pad: 'none', className: CLASS_ROOT + '__controls-primary',
	            direction: 'row', justify: 'between' },
	          _react2.default.createElement(
	            _Box2.default,
	            { direction: 'row', align: 'center',
	              pad: { horizontal: 'small', vertical: 'none' } },
	            _react2.default.createElement(_PlayButton2.default, { playing: playing, ended: ended, iconSize: 'medium',
	              togglePlay: togglePlay, primary: false }),
	            this._renderTitle()
	          ),
	          _react2.default.createElement(
	            _Box2.default,
	            { direction: 'row', align: 'center',
	              pad: { horizontal: 'small', vertical: 'none' } },
	            _react2.default.createElement(_Time2.default, { currentTime: currentTime, duration: duration }),
	            this._renderMuteButton(),
	            allowFullScreen ? _react2.default.createElement(_FullscreenButton2.default, { onClick: fullscreen }) : undefined
	          )
	        )
	      );
	
	      return overlayContent;
	    }
	  }]);
	
	  return Controls;
	}(_react.Component);
	
	Controls.displayName = 'Controls';
	exports.default = Controls;
	
	
	Controls.contextTypes = {
	  intl: _propTypes2.default.object
	};
	module.exports = exports['default'];

/***/ }),

/***/ 354:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Intl = __webpack_require__(5);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _CSSClassnames = __webpack_require__(3);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Button = __webpack_require__(25);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Expand = __webpack_require__(341);
	
	var _Expand2 = _interopRequireDefault(_Expand);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.VIDEO;
	var BUTTON_CLASS = CLASS_ROOT + '__button';
	
	var FullscreenButton = function (_Component) {
	  _inherits(FullscreenButton, _Component);
	
	  function FullscreenButton() {
	    _classCallCheck(this, FullscreenButton);
	
	    return _possibleConstructorReturn(this, (FullscreenButton.__proto__ || Object.getPrototypeOf(FullscreenButton)).apply(this, arguments));
	  }
	
	  _createClass(FullscreenButton, [{
	    key: 'shouldComponentUpdate',
	
	
	    // prevents unnecessarily updates/re-renders
	    // only update component if the onClick prop changes
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props.onClick !== nextProps.onClick;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var a11yExpandButtonTitle = _Intl2.default.getMessage(this.context.intl, 'Toggle Fullscreen');
	
	      return _react2.default.createElement(
	        _Button2.default,
	        { plain: true, className: BUTTON_CLASS, onClick: this.props.onClick,
	          a11yTitle: a11yExpandButtonTitle },
	        _react2.default.createElement(_Expand2.default, { className: BUTTON_CLASS + '__icon',
	          colorIndex: 'brand' })
	      );
	    }
	  }]);
	
	  return FullscreenButton;
	}(_react.Component);
	
	FullscreenButton.displayName = 'FullscreenButton';
	exports.default = FullscreenButton;
	
	
	FullscreenButton.propTypes = {
	  onClick: _propTypes2.default.func
	};
	module.exports = exports['default'];

/***/ }),

/***/ 355:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Box = __webpack_require__(7);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _Heading = __webpack_require__(41);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _Share = __webpack_require__(357);
	
	var _Share2 = _interopRequireDefault(_Share);
	
	var _PlayButton = __webpack_require__(161);
	
	var _PlayButton2 = _interopRequireDefault(_PlayButton);
	
	var _CSSClassnames = __webpack_require__(3);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.VIDEO;
	
	var Overlay = function (_Component) {
	  _inherits(Overlay, _Component);
	
	  function Overlay(props, context) {
	    _classCallCheck(this, Overlay);
	
	    var _this = _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call(this, props, context));
	
	    _this._onResponsive = _this._onResponsive.bind(_this);
	    _this.state = {
	      iconSize: props.size && (props.size === 'small' || props.size === 'medium') ? 'large' : 'xlarge'
	    };
	    return _this;
	  }
	
	  _createClass(Overlay, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      if (newProps.size !== this.props.size) {
	        this.setState({
	          iconSize: newProps.size && (newProps.size === 'small' || newProps.size === 'medium') ? 'large' : 'xlarge'
	        });
	      }
	    }
	  }, {
	    key: '_onResponsive',
	    value: function _onResponsive(small) {
	      if (small) {
	        this.setState({ iconSize: 'medium' });
	      } else {
	        var iconSize = 'small' === this.props.size ? undefined : 'xlarge';
	        this.setState({ iconSize: iconSize });
	      }
	    }
	  }, {
	    key: '_renderReplayMenu',
	    value: function _renderReplayMenu() {
	      var _props = this.props,
	          ended = _props.ended,
	          shareLink = _props.shareLink,
	          shareHeadline = _props.shareHeadline,
	          shareText = _props.shareText;
	
	
	      var replayContent = void 0;
	      if (ended) {
	        replayContent = _react2.default.createElement(
	          _Box2.default,
	          { className: CLASS_ROOT + '__replay', align: 'center' },
	          _react2.default.createElement(
	            _Heading2.default,
	            { tag: 'h3', strong: true, uppercase: true },
	            'Replay'
	          ),
	          _react2.default.createElement(_Share2.default, { shareLink: shareLink, shareHeadline: shareHeadline,
	            shareText: shareText })
	        );
	      }
	
	      return replayContent;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          ended = _props2.ended,
	          playing = _props2.playing,
	          togglePlay = _props2.togglePlay,
	          videoHeader = _props2.videoHeader;
	
	
	      return _react2.default.createElement(
	        _Box2.default,
	        { pad: 'none', align: 'center', justify: 'center',
	          className: CLASS_ROOT + '__overlay' },
	        videoHeader,
	        _react2.default.createElement(
	          _Box2.default,
	          { pad: 'none', align: 'center', justify: 'center' },
	          _react2.default.createElement(_PlayButton2.default, { iconSize: this.state.iconSize,
	            playing: playing,
	            ended: ended,
	            togglePlay: togglePlay })
	        ),
	        this._renderReplayMenu()
	      );
	    }
	  }]);
	
	  return Overlay;
	}(_react.Component);
	
	Overlay.displayName = 'Overlay';
	exports.default = Overlay;
	module.exports = exports['default'];

/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Intl = __webpack_require__(5);
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _CSSClassnames = __webpack_require__(3);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Button = __webpack_require__(25);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CirclePlay = __webpack_require__(160);
	
	var _CirclePlay2 = _interopRequireDefault(_CirclePlay);
	
	var _Play = __webpack_require__(344);
	
	var _Play2 = _interopRequireDefault(_Play);
	
	var _Pause = __webpack_require__(343);
	
	var _Pause2 = _interopRequireDefault(_Pause);
	
	var _Refresh = __webpack_require__(345);
	
	var _Refresh2 = _interopRequireDefault(_Refresh);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.VIDEO;
	var BUTTON_CLASS = CLASS_ROOT + '__button';
	
	var PlayButton = function (_Component) {
	  _inherits(PlayButton, _Component);
	
	  function PlayButton() {
	    _classCallCheck(this, PlayButton);
	
	    return _possibleConstructorReturn(this, (PlayButton.__proto__ || Object.getPrototypeOf(PlayButton)).apply(this, arguments));
	  }
	
	  _createClass(PlayButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          ended = _props.ended,
	          iconSize = _props.iconSize,
	          playing = _props.playing,
	          primary = _props.primary,
	          togglePlay = _props.togglePlay;
	      var intl = this.context.intl;
	
	
	      var PIcon = primary ? _CirclePlay2.default : _Play2.default;
	      var Icon = playing ? _Pause2.default : ended ? _Refresh2.default : PIcon;
	      var controlIcon = _react2.default.createElement(Icon, { className: BUTTON_CLASS + '__icon', size: iconSize,
	        colorIndex: 'brand' });
	
	      var a11yControlButtonMessage = playing ? 'Pause Video' : ended ? 'Restart Video' : 'Play Video';
	
	      var a11yControlButtonTitle = _Intl2.default.getMessage(intl, a11yControlButtonMessage);
	
	      return _react2.default.createElement(
	        _Button2.default,
	        { plain: true, className: BUTTON_CLASS, onClick: togglePlay,
	          a11yTitle: a11yControlButtonTitle },
	        controlIcon
	      );
	    }
	  }]);
	
	  return PlayButton;
	}(_react.Component);
	
	PlayButton.displayName = 'PlayButton';
	exports.default = PlayButton;
	
	
	PlayButton.propTypes = {
	  iconSize: _propTypes2.default.oneOf(['small', 'medium', 'large', 'xlarge', 'huge']),
	  playing: _propTypes2.default.bool,
	  primary: _propTypes2.default.bool,
	  ended: _propTypes2.default.bool,
	  togglePlay: _propTypes2.default.func
	};
	
	PlayButton.defaultProps = {
	  iconSize: 'xlarge',
	  primary: true
	};
	module.exports = exports['default'];

/***/ }),

/***/ 356:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(4);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _Box = __webpack_require__(7);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _CSSClassnames = __webpack_require__(3);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.VIDEO;
	
	var ProgressBar = function (_Component) {
	  _inherits(ProgressBar, _Component);
	
	  function ProgressBar() {
	    _classCallCheck(this, ProgressBar);
	
	    var _this = _possibleConstructorReturn(this, (ProgressBar.__proto__ || Object.getPrototypeOf(ProgressBar)).call(this));
	
	    _this._onProgressBarChange = _this._onProgressBarChange.bind(_this);
	    return _this;
	  }
	
	  // prevents unnecessarily updates/re-renders
	
	
	  _createClass(ProgressBar, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props.progress !== nextProps.progress;
	    }
	  }, {
	    key: '_onProgressBarChange',
	    value: function _onProgressBarChange(e) {
	      this.props.onChange(e.target.value * this.props.duration / 100);
	    }
	  }, {
	    key: '_onChapterClick',
	    value: function _onChapterClick(time) {
	      this.props.onChange(time);
	    }
	  }, {
	    key: '_onMouseOver',
	    value: function _onMouseOver(index) {
	      this.props.onChapterHover(index);
	    }
	  }, {
	    key: '_renderChapterMarkers',
	    value: function _renderChapterMarkers() {
	      var _this2 = this;
	
	      var _props = this.props,
	          duration = _props.duration,
	          timeline = _props.timeline;
	
	
	      if (timeline) {
	        var chapters = timeline.map(function (chapter, index, chapters) {
	          var percent = chapter.time / duration * 100;
	          var tickClasses = (0, _classnames3.default)(CLASS_ROOT + '__chapter-marker-tick', _defineProperty({}, CLASS_ROOT + '__chapter-marker-tick-start', percent === 0));
	
	          return _react2.default.createElement(
	            'div',
	            { className: CLASS_ROOT + '__chapter-marker', key: chapter.time,
	              style: { width: percent + '%' } },
	            _react2.default.createElement('div', { className: tickClasses,
	              onMouseOver: _this2._onMouseOver.bind(_this2, index),
	              onMouseOut: _this2.props.onChapterHover,
	              onFocus: _this2._onMouseOver.bind(_this2, index),
	              onBlur: _this2.props.onChapterHover,
	              onClick: _this2._onChapterClick.bind(_this2, chapter.time) }),
	            _react2.default.createElement('div', { className: CLASS_ROOT + '__chapter-marker-track' })
	          );
	        });
	
	        return _react2.default.createElement(
	          'div',
	          { className: CLASS_ROOT + '__chapter-markers' },
	          chapters
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          progress = _props2.progress,
	          timeline = _props2.timeline;
	
	
	      return _react2.default.createElement(
	        _Box2.default,
	        { pad: 'none', className: CLASS_ROOT + '__progress', direction: 'row' },
	        _react2.default.createElement('div', { className: CLASS_ROOT + '__progress-bar-fill', style: {
	            width: progress + '%'
	          } }),
	        timeline ? this._renderChapterMarkers() : undefined,
	        _react2.default.createElement('input', { className: CLASS_ROOT + '__progress-bar-input',
	          onChange: this._onProgressBarChange,
	          type: 'range',
	          min: '0',
	          max: '100',
	          value: progress || '',
	          step: '0.1' })
	      );
	    }
	  }]);
	
	  return ProgressBar;
	}(_react.Component);
	
	ProgressBar.displayName = 'ProgressBar';
	exports.default = ProgressBar;
	
	
	ProgressBar.propTypes = {
	  onClick: _propTypes2.default.func,
	  duration: _propTypes2.default.number,
	  progress: _propTypes2.default.number,
	  onChapterHover: _propTypes2.default.func
	};
	
	ProgressBar.defaultProps = {
	  duration: 0,
	  progress: 0
	};
	module.exports = exports['default'];

/***/ }),

/***/ 357:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(9);
	
	var _Box = __webpack_require__(7);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _SocialShare = __webpack_require__(337);
	
	var _SocialShare2 = _interopRequireDefault(_SocialShare);
	
	var _Form = __webpack_require__(329);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormField = __webpack_require__(330);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	var _CSSClassnames = __webpack_require__(3);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.VIDEO;
	var BUTTON_CLASS = CLASS_ROOT + '__button';
	
	var Overlay = function (_Component) {
	  _inherits(Overlay, _Component);
	
	  function Overlay() {
	    _classCallCheck(this, Overlay);
	
	    var _this = _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call(this));
	
	    _this._onClickShareLink = _this._onClickShareLink.bind(_this);
	    return _this;
	  }
	
	  _createClass(Overlay, [{
	    key: '_onClickShareLink',
	    value: function _onClickShareLink() {
	      (0, _reactDom.findDOMNode)(this.shareLinkRef).select();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          shareLink = _props.shareLink,
	          shareHeadline = _props.shareHeadline,
	          shareText = _props.shareText;
	
	      // this has to be null to be a valid react children
	
	      var shareContent = null;
	      if (shareLink) {
	        shareContent = _react2.default.createElement(
	          _Box2.default,
	          { align: 'center' },
	          _react2.default.createElement(
	            _Form2.default,
	            { pad: { vertical: 'small' } },
	            _react2.default.createElement(
	              _FormField2.default,
	              { strong: true },
	              _react2.default.createElement('input', { ref: function ref(_ref) {
	                  return _this2.shareLinkRef = _ref;
	                },
	                className: 'share-link', type: 'text', value: shareLink,
	                onClick: this._onClickShareLink, readOnly: true })
	            )
	          ),
	          _react2.default.createElement(
	            _Box2.default,
	            { direction: 'row', className: BUTTON_CLASS },
	            _react2.default.createElement(_SocialShare2.default, { type: 'email', link: shareLink, colorIndex: 'brand',
	              className: BUTTON_CLASS + '__icon',
	              title: shareHeadline, text: shareText }),
	            _react2.default.createElement(_SocialShare2.default, { type: 'twitter', colorIndex: 'brand',
	              className: BUTTON_CLASS + '__icon',
	              link: shareLink, text: shareHeadline }),
	            _react2.default.createElement(_SocialShare2.default, { type: 'facebook', colorIndex: 'brand',
	              className: BUTTON_CLASS + '__icon',
	              link: shareLink }),
	            _react2.default.createElement(_SocialShare2.default, { type: 'linkedin', colorIndex: 'brand',
	              className: BUTTON_CLASS + '__icon',
	              link: shareLink, title: shareHeadline, text: shareText })
	          )
	        );
	      }
	
	      return shareContent;
	    }
	  }]);
	
	  return Overlay;
	}(_react.Component);
	
	Overlay.displayName = 'Overlay';
	exports.default = Overlay;
	
	
	Overlay.propTypes = {
	  shareLink: _propTypes2.default.string,
	  shareHeadline: _propTypes2.default.string,
	  shareText: _propTypes2.default.string
	};
	
	Overlay.defaultProps = {
	  shareHeadline: '',
	  shareText: ''
	};
	module.exports = exports['default'];

/***/ }),

/***/ 358:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Box = __webpack_require__(7);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _Heading = __webpack_require__(41);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _CSSClassnames = __webpack_require__(3);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _FormatTime = __webpack_require__(174);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.VIDEO;
	
	var Time = function (_Component) {
	  _inherits(Time, _Component);
	
	  function Time() {
	    _classCallCheck(this, Time);
	
	    return _possibleConstructorReturn(this, (Time.__proto__ || Object.getPrototypeOf(Time)).apply(this, arguments));
	  }
	
	  _createClass(Time, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          currentTime = _props.currentTime,
	          duration = _props.duration;
	
	
	      return _react2.default.createElement(
	        _Box2.default,
	        { pad: { horizontal: 'small', vertical: 'none' } },
	        _react2.default.createElement(
	          _Heading2.default,
	          { tag: 'h3', margin: 'none', className: CLASS_ROOT + '__time' },
	          (0, _FormatTime.formatTime)(currentTime),
	          ' / ',
	          (0, _FormatTime.formatTime)(duration)
	        )
	      );
	    }
	  }]);
	
	  return Time;
	}(_react.Component);
	
	Time.displayName = 'Time';
	exports.default = Time;
	
	
	Time.propTypes = {
	  currentTime: _propTypes2.default.number,
	  duration: _propTypes2.default.number
	};
	module.exports = exports['default'];

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.announcePageLoaded = announcePageLoaded;
	exports.announce = announce;
	
	var _CSSClassnames = __webpack_require__(3);
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CLASS_ROOT = _CSSClassnames2.default.APP; // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	function clearAnnouncer() {
	  var announcer = document.querySelector('.' + CLASS_ROOT + '__announcer');
	  if (announcer) {
	    announcer.innerHTML = '';
	  }
	};
	
	function announcePageLoaded(title) {
	  announce(title + ' page was loaded');
	}
	
	function announce(message) {
	  var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'assertive';
	
	  var announcer = document.querySelector('.' + CLASS_ROOT + '__announcer');
	  if (announcer) {
	    announcer.setAttribute('aria-live', 'off');
	    announcer.innerHTML = message;
	    setTimeout(clearAnnouncer, 500);
	    announcer.setAttribute('aria-live', mode);
	  }
	}
	
	exports.default = { announce: announce, announcePageLoaded: announcePageLoaded };

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// (C) Copyright 2016 Hewlett Packard Enterprise Development LP
	
	var namespace = exports.namespace = 'grommetux-';
	
	exports.default = {
	  ACCORDION: namespace + 'accordion',
	  ACCORDION_PANEL: namespace + 'accordion-panel',
	  ANCHOR: namespace + 'anchor',
	  ANIMATE: namespace + 'animate',
	  APP: namespace + 'app',
	  ARTICLE: namespace + 'article',
	  ATTRIBUTE: namespace + 'attribute',
	  BACKGROUND_COLOR_INDEX: namespace + 'background-color-index',
	  BOX: namespace + 'box',
	  BORDER_COLOR_INDEX: namespace + 'border-color-index',
	  BRICK: namespace + 'brick',
	  BUTTON: namespace + 'button',
	  CALENDAR: namespace + 'calendar',
	  CARD: namespace + 'card',
	  CAROUSEL: namespace + 'carousel',
	  CAROUSEL_CONTROLS: namespace + 'carousel-controls',
	  CHART: namespace + 'chart',
	  CHART_AXIS: namespace + 'chart-axis',
	  CHART_BASE: namespace + 'chart-base',
	  CHART_GRAPH: namespace + 'chart-graph',
	  CHART_GRID: namespace + 'chart-grid',
	  CHART_HOT_SPOTS: namespace + 'chart-hot-spots',
	  CHART_LAYERS: namespace + 'chart-layers',
	  CHART_MARKER: namespace + 'chart-marker',
	  CHART_MARKER_LABEL: namespace + 'chart-marker-label',
	  CHART_RANGE: namespace + 'chart-range',
	  CHECK_BOX: namespace + 'check-box',
	  COLLAPSIBLE: namespace + 'collapsible',
	  COLOR_INDEX: namespace + 'color-index',
	  COLUMNS: namespace + 'columns',
	  CONTROL_ICON: namespace + 'control-icon',
	  DATE_TIME: namespace + 'date-time',
	  DATE_TIME_DROP: namespace + 'date-time-drop',
	  DISTRIBUTION: namespace + 'distribution',
	  DROP: namespace + 'drop',
	  FOOTER: namespace + 'footer',
	  FORM: namespace + 'form',
	  FORM_FIELD: namespace + 'form-field',
	  FORM_FIELDS: namespace + 'form-fields',
	  HEADER: namespace + 'header',
	  HEADING: namespace + 'heading',
	  HEADLINE: namespace + 'headline',
	  HERO: namespace + 'hero',
	  IMAGE: namespace + 'image',
	  IMAGE_FIELD: namespace + 'image-field',
	  INPUT: namespace + 'input',
	  LABEL: namespace + 'label',
	  LAYER: namespace + 'layer',
	  LEGEND: namespace + 'legend',
	  LIST: namespace + 'list',
	  LIST_ITEM: namespace + 'list-item',
	  LOGIN: namespace + 'login',
	  LOGIN_FORM: namespace + 'login-form',
	  LOGO_ICON: namespace + 'logo-icon',
	  MAP: namespace + 'map',
	  MENU: namespace + 'menu',
	  METER: namespace + 'meter',
	  NAMESPACE: '' + namespace,
	  NOTIFICATION: namespace + 'notification',
	  NUMBER_INPUT: namespace + 'number-input',
	  OBJECT: namespace + 'object',
	  PARAGRAPH: namespace + 'paragraph',
	  PASSWORD_INPUT: namespace + 'password-input',
	  PULSE: namespace + 'pulse',
	  QUOTE: namespace + 'quote',
	  RADIO_BUTTON: namespace + 'radio-button',
	  SEARCH: namespace + 'search',
	  SEARCH_INPUT: namespace + 'search-input',
	  SECTION: namespace + 'section',
	  SELECT: namespace + 'select',
	  SIDEBAR: namespace + 'sidebar',
	  SKIP_LINK_ANCHOR: namespace + 'skip-link-anchor',
	  SKIP_LINKS: namespace + 'skip-links',
	  SPLIT: namespace + 'split',
	  SPINNING: namespace + 'icon-spinning',
	  STATUS_ICON: namespace + 'status-icon',
	  SUN_BURST: namespace + 'sun-burst',
	  TAB: namespace + 'tab',
	  TABLE: namespace + 'table',
	  TABLE_ROW: namespace + 'table-row',
	  TABS: namespace + 'tabs',
	  TAG: namespace + 'tag',
	  TAGS: namespace + 'tags',
	  TBD: namespace + 'tbd',
	  TEXT_INPUT: namespace + 'text-input',
	  TILE: namespace + 'tile',
	  TILES: namespace + 'tiles',
	  TIMESTAMP: namespace + 'timestamp',
	  TIP: namespace + 'tip',
	  TITLE: namespace + 'title',
	  TOAST: namespace + 'toast',
	  TOPOLOGY: namespace + 'topology',
	  VALUE: namespace + 'value',
	  VIDEO: namespace + 'video',
	  WORLD_MAP: namespace + 'world-map'
	};

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.findScrollParents = findScrollParents;
	exports.isDescendant = isDescendant;
	exports.findAncestor = findAncestor;
	exports.filterByFocusable = filterByFocusable;
	exports.getBestFirstFocusable = getBestFirstFocusable;
	exports.isFormElement = isFormElement;
	exports.generateId = generateId;
	exports.generateUUID = generateUUID;
	exports.checkDarkBackground = checkDarkBackground;
	// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var COLOR_RGB_REGEXP = /rgb\((\d+), (\d+), (\d+)\)/;
	var COLOR_RGBA_REGEXP = /rgba\((\d+), (\d+), (\d+), ([\d\.]+)\)/;
	var LIGHT_HINT_REGEXP = /^light/;
	
	function hash(input) {
	  var hash = 0,
	      i,
	      chr,
	      len;
	  if (input.length === 0) return hash;
	  for (i = 0, len = input.length; i < len; i++) {
	    chr = input.charCodeAt(i);
	    hash = (hash << 5) - hash + chr;
	    hash = hash & hash; // Convert to 32bit integer
	  }
	  return hash;
	};
	
	function findScrollParents(element, horizontal) {
	  var result = [];
	  var parent = element.parentNode;
	  while (parent && parent.getBoundingClientRect) {
	    var rect = parent.getBoundingClientRect();
	    // 10px is to account for borders and scrollbars in a lazy way
	    if (horizontal) {
	      if (rect.width && parent.scrollWidth > rect.width + 10) {
	        result.push(parent);
	      }
	    } else {
	      if (rect.height && parent.scrollHeight > rect.height + 10) {
	        result.push(parent);
	      }
	    }
	    parent = parent.parentNode;
	  }
	  // last scrollable element will be the document 
	  // if nothing else is scrollable in the page
	  if (result.length === 0) {
	    result.push(document);
	  }
	  return result;
	}
	
	function isDescendant(parent, child) {
	  var node = child.parentNode;
	  while (node != null) {
	    if (node == parent) {
	      return true;
	    }
	    node = node.parentNode;
	  }
	  return false;
	}
	
	function findAncestor(element, className) {
	  var node = element.parentNode;
	  while (node != null) {
	    if (node.classList && node.classList.contains(className)) {
	      break;
	    }
	    node = node.parentNode;
	  }
	  return node;
	}
	
	function filterByFocusable(elements) {
	  return Array.prototype.filter.call(elements || [], function (element) {
	    var currentTag = element.tagName.toLowerCase();
	    var validTags = /(svg|a|area|input|select|textarea|button|iframe|div)$/;
	    var isValidTag = currentTag.match(validTags) && element.focus;
	
	    if (currentTag === 'a') {
	      return isValidTag && element.childNodes.length > 0 && element.getAttribute('href');
	    } else if (currentTag === 'svg' || currentTag === 'div') {
	      return isValidTag && element.hasAttribute('tabindex');
	    }
	
	    return isValidTag;
	  });
	}
	
	function getBestFirstFocusable(elements) {
	  var bestFirstFocusable;
	
	  Array.prototype.some.call(elements || [], function (element) {
	    var currentTag = element.tagName.toLowerCase();
	    var isValidTag = currentTag.match(/(input|select|textarea)$/);
	    return isValidTag ? (bestFirstFocusable = element, true) : false;
	  });
	
	  if (!bestFirstFocusable) {
	    bestFirstFocusable = this.filterByFocusable(elements)[0];
	  }
	
	  return bestFirstFocusable;
	}
	
	function isFormElement(element) {
	  var elementType = element ? element.tagName.toLowerCase() : undefined;
	  return elementType && (elementType === 'input' || elementType === 'textarea');
	}
	
	function generateId(element) {
	  if (element) {
	    var id = void 0;
	    var elementId = element.getAttribute('id');
	    if (!elementId) {
	      // IE11 fix: check for parentNode instead of parentElement
	      var parentElement = element.parentElement || element.parentNode;
	      if (parentElement) {
	        id = hash(parentElement.innerHTML);
	        element.setAttribute('id', id);
	      }
	    } else {
	      id = elementId;
	    }
	    return id;
	  }
	}
	
	function generateUUID() {
	  function S4() {
	    return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
	  }
	  var uuid = '' + S4() + S4() + ('-' + S4() + '-4' + S4().substr(0, 3)) + ('-' + S4() + '-' + S4() + S4() + S4()).toLowerCase();
	  return uuid;
	}
	
	var CHECK_DARK_BACKGROUND_BACKOFFS = [0, 20, 80, 200];
	
	function hasDarkBackground(element) {
	  var result = false;
	  var color = window.getComputedStyle(element).backgroundColor;
	  var match = color.match(COLOR_RGB_REGEXP) || color.match(COLOR_RGBA_REGEXP);
	  if (match) {
	    var _match$slice$map = match.slice(1).map(function (n) {
	      return parseInt(n, 10);
	    }),
	        _match$slice$map2 = _slicedToArray(_match$slice$map, 3),
	        red = _match$slice$map2[0],
	        green = _match$slice$map2[1],
	        blue = _match$slice$map2[2];
	    // http://www.had2know.com/technology/
	    //  color-contrast-calculator-web-design.html
	
	
	    var brightness = (299 * red + 587 * green + 114 * blue) / 1000;
	    if (0 === brightness) {
	      // Browsers return 0,0,0 when they don't know yet.
	      result = undefined;
	      // changed threshold below to accomodate the Aruba theme for now
	    } else if (brightness < 137) {
	      ///125) {
	      result = true;
	    }
	  }
	  return result;
	}
	
	function checkDarkBackgroundBackoff(element, handler, backoffDurations) {
	  return setTimeout(function () {
	    var dark = hasDarkBackground(element);
	    if (undefined === dark && backoffDurations.length > 0) {
	      checkDarkBackgroundBackoff(element, handler, backoffDurations);
	    } else {
	      handler(dark);
	    }
	  }, backoffDurations.shift());
	}
	
	function checkDarkBackground(colorIndex, element, handler) {
	  var timer = void 0;
	  if (colorIndex) {
	    if ('dark' === colorIndex) {
	      // caller knows
	      handler(true);
	    } else if (LIGHT_HINT_REGEXP.test(colorIndex)) {
	      // skip if this is a 'light-*' color index
	      handler(false);
	    } else {
	      // Measure the actual background color brightness to determine whether
	      // to set a dark or light context.
	      if (element && window.getComputedStyle) {
	        timer = checkDarkBackgroundBackoff(element, handler, CHECK_DARK_BACKGROUND_BACKOFFS);
	      }
	    }
	  }
	  return { stop: function stop() {
	      return clearTimeout(timer);
	    } };
	}

/***/ }),

/***/ 174:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatTime = formatTime;
	function formatTime(seconds) {
	  var date = new Date(null);
	  seconds = isNaN(seconds) ? 0 : Math.floor(seconds);
	  date.setSeconds(seconds);
	
	  var dateISOString = date.toISOString();
	  var time = dateISOString.substr(11, 8);
	  if (seconds < 3600) {
	    time = dateISOString.substr(14, 5);
	  }
	
	  return time;
	}

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// (C) Copyright 2014 Hewlett Packard Enterprise Development LP
	exports.default = {
	  getMessage: function getMessage(intl, key, values) {
	    if (intl) {
	      return intl.formatMessage({
	        id: key,
	        defaultMessage: key
	      }, values);
	    } else {
	      return key;
	    }
	  }
	};
	module.exports = exports["default"];

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactDom = __webpack_require__(9);
	
	var _DOM = __webpack_require__(16);
	
	// Allow callers to use key labels instead of key code numbers.
	// This makes their code easier to read.
	// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var KEYS = {
	  backspace: 8,
	  tab: 9,
	  enter: 13,
	  esc: 27,
	  escape: 27,
	  space: 32,
	  left: 37,
	  up: 38,
	  right: 39,
	  down: 40,
	  comma: 188,
	  shift: 16
	};
	
	var _keyboardAccelerators = {};
	var _listeners = [];
	var _isKeyboardAcceleratorListening = false;
	
	var _onKeyboardAcceleratorKeyPress = function _onKeyboardAcceleratorKeyPress(e) {
	  var key = e.keyCode ? e.keyCode : e.which;
	  _listeners.slice().reverse().some(function (listener) {
	    if (_keyboardAccelerators[listener]) {
	      var handlers = _keyboardAccelerators[listener].handlers;
	      if (handlers.hasOwnProperty(key)) {
	        if (handlers[key] && handlers[key](e)) {
	          return true;
	        }
	      }
	    }
	    return false;
	  });
	};
	
	// KeyboardAccelerators is a utility for handling keyboard events.
	// Add listeners using startListeningToKeyboard().
	// Remove listeners using stopListeningToKeyboard().
	exports.default = {
	  _initKeyboardAccelerators: function _initKeyboardAccelerators(element) {
	    var id = (0, _DOM.generateId)(element);
	    _keyboardAccelerators[id] = {
	      handlers: {}
	    };
	  },
	  _getKeyboardAcceleratorHandlers: function _getKeyboardAcceleratorHandlers(element) {
	    var id = (0, _DOM.generateId)(element);
	    return _keyboardAccelerators[id].handlers;
	  },
	  _getDowns: function _getDowns(element) {
	    var id = (0, _DOM.generateId)(element);
	    return _keyboardAccelerators[id].downs;
	  },
	  _isComponentListening: function _isComponentListening(element) {
	    var id = (0, _DOM.generateId)(element);
	
	    return _listeners.some(function (listener) {
	      return listener === id;
	    });
	  },
	  _subscribeComponent: function _subscribeComponent(element) {
	    var id = (0, _DOM.generateId)(element);
	    _listeners.push(id);
	  },
	  _unsubscribeComponent: function _unsubscribeComponent(element) {
	    var id = (0, _DOM.generateId)(element);
	
	    var removeListenerIndex = _listeners.indexOf(id);
	    _listeners.splice(removeListenerIndex, 1);
	
	    delete _keyboardAccelerators[id];
	  },
	
	
	  // Add handlers for specific keys.
	  // This function can be called multiple times, existing handlers will
	  // be replaced, new handlers will be added.
	  startListeningToKeyboard: function startListeningToKeyboard(component, handlers) {
	    var element = (0, _reactDom.findDOMNode)(component);
	    if (element) {
	      this._initKeyboardAccelerators(element);
	      var keys = 0;
	      for (var key in handlers) {
	        if (handlers.hasOwnProperty(key)) {
	          var keyCode = key;
	          if (KEYS.hasOwnProperty(key)) {
	            keyCode = KEYS[key];
	          }
	          keys += 1;
	          this._getKeyboardAcceleratorHandlers(element)[keyCode] = handlers[key];
	        }
	      }
	
	      if (keys > 0) {
	        if (!_isKeyboardAcceleratorListening) {
	          window.addEventListener("keydown", _onKeyboardAcceleratorKeyPress);
	          _isKeyboardAcceleratorListening = true;
	        }
	        if (!this._isComponentListening(element)) {
	          this._subscribeComponent(element);
	        }
	      }
	    }
	  },
	
	
	  // Remove handlers for all keys or specific keys.
	  // If no argument is passed in, all handlers are removed.
	  // This function can be called multiple times, only the handlers
	  // specified will be removed.
	  stopListeningToKeyboard: function stopListeningToKeyboard(component, handlers) {
	    var element = (0, _reactDom.findDOMNode)(component);
	    if (!this._isComponentListening(element)) {
	      return;
	    }
	    if (handlers) {
	      for (var key in handlers) {
	        if (handlers.hasOwnProperty(key)) {
	          var keyCode = key;
	          if (KEYS.hasOwnProperty(key)) {
	            keyCode = KEYS[key];
	          }
	          delete this._getKeyboardAcceleratorHandlers(element)[keyCode];
	        }
	      }
	    }
	
	    var keyCount = 0;
	    for (var keyHandler in this._getKeyboardAcceleratorHandlers(element)) {
	      if (this._getKeyboardAcceleratorHandlers(element).hasOwnProperty(keyHandler)) {
	        keyCount += 1;
	      }
	    }
	
	    if (!handlers || 0 === keyCount) {
	      this._initKeyboardAccelerators(element);
	      this._unsubscribeComponent(element);
	    }
	
	    if (_listeners.length === 0) {
	      window.removeEventListener("keydown", _onKeyboardAcceleratorKeyPress);
	      _isKeyboardAcceleratorListening = false;
	    }
	  }
	};
	module.exports = exports['default'];

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	exports.default = {
	  pick: function pick(props, fields) {
	    var has = function has(p) {
	      return props.hasOwnProperty(p);
	    };
	    var obj = {};
	    (fields || []).forEach(function (field) {
	      if (has(field)) obj[field] = props[field];
	    });
	    return obj;
	  },
	  omit: function omit(props, fields) {
	    var obj = {};
	    Object.keys(props).forEach(function (p) {
	      if ((fields || []).indexOf(p) === -1) {
	        obj[p] = props[p];
	      }
	    });
	    return obj;
	  }
	};
	module.exports = exports["default"];

/***/ }),

/***/ 107:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.smallSize = smallSize;
	// (C) Copyright 2014 Hewlett Packard Enterprise Development LP
	
	/*
	 * Responsive is a utility for tracking the display size.
	 * It aligns with CSS media queries.
	 */
	
	var SMALL_WIDTH_EM = 44.9375; // align with _settings.responsive.scss
	
	function smallSize() {
	  var fontSize = '16px';
	  // unit tests don't have getComputedStyle
	  if (window.getComputedStyle) {
	    fontSize = window.getComputedStyle(document.documentElement).fontSize;
	  }
	  return SMALL_WIDTH_EM * parseFloat(fontSize);
	}
	
	exports.default = {
	
	  // Track responsive sizing.
	  //
	  // Example:
	  // inside componentDidMount()
	  //   this._responsive = Responsive.start(this._onResponsive);
	  // inside componentWillUnmount()
	  //   this._responsive.stop()
	
	  start: function start(func) {
	    var responsive = {
	      func: func,
	      timer: undefined,
	      small: undefined,
	      smallSize: this.smallSize()
	    };
	    responsive.onResize = this._onResize.bind(this, responsive);
	    responsive.layout = this._check.bind(this, responsive);
	    responsive.stop = this._stop.bind(this, responsive);
	    window.addEventListener('resize', responsive.onResize);
	    responsive.layout();
	    return responsive;
	  },
	  _stop: function _stop(responsive) {
	    clearTimeout(responsive.timer);
	    window.removeEventListener('resize', responsive.onResize);
	  },
	  _onResize: function _onResize(responsive) {
	    // Don't debounce so we align more closely with how the stylesheets are
	    // processed.
	    responsive.layout();
	  },
	  _check: function _check(responsive) {
	    if (window.innerWidth <= responsive.smallSize) {
	      if (!responsive.small) {
	        responsive.small = true;
	        responsive.func(true);
	      }
	    } else {
	      if (false !== responsive.small) {
	        responsive.small = false;
	        responsive.func(false);
	      }
	    }
	  },
	
	
	  smallSize: smallSize
	};

/***/ }),

/***/ 363:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (fn) {
	  var threshhold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;
	  var scope = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this;
	
	  var last = void 0;
	  var deferTimer = void 0;
	
	  return function () {
	    var now = Date.now();
	    if (last && now < last + threshhold) {
	      clearTimeout(deferTimer);
	      deferTimer = setTimeout(function () {
	        last = now;
	        fn.apply(scope, arguments);
	      }, threshhold);
	    } else {
	      last = now;
	      fn.apply(scope, arguments);
	    }
	  };
	};
	
	module.exports = exports["default"]; // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

/***/ }),

/***/ 178:
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};


/***/ }),

/***/ 27:
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),

/***/ 124:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  any: { type: 'any' },
	  array: { type: 'array' },
	  bool: { type: 'bool' },
	  element: { type: 'element' },
	  func: { type: 'func' },
	  node: { type: 'node' },
	  number: { type: 'number' },
	  object: { type: 'object' },
	  string: { type: 'string' },
	  symbol: { type: 'symbol' },
	  arrayOf: function arrayOf(args) {
	    return { type: 'arrayOf', args: args };
	  },
	  instanceOf: function instanceOf(args) {
	    return { type: 'instanceOf', args: args };
	  },
	  objectOf: function objectOf(args) {
	    return { type: 'objectOf', args: args };
	  },
	  oneOfType: function oneOfType(args) {
	    return { type: 'oneOfType', args: args };
	  },
	  oneOf: function oneOf(args) {
	    return { type: 'oneOf', args: args };
	  },
	  shape: function shape(args) {
	    return { type: 'shape', args: args };
	  }
	};

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = docPropType;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getArgs(args) {
	  return args.map(function (arg) {
	    if (arg.type && _propTypes2.default[arg.type]) {
	      if (arg.args) {
	        if (arg.type === 'shape') {
	          return buildShapePropType(arg);
	        }
	        return _propTypes2.default[arg.type](arg.args);
	      }
	      return _propTypes2.default[arg.type];
	    }
	    return arg;
	  });
	}
	
	function getPropType(validate) {
	  return _propTypes2.default[validate.type](validate.args.type && _propTypes2.default[validate.args.type] ? _propTypes2.default[validate.args.type] : validate.args);
	}
	
	// function to recursively build the proptype for shape
	function buildShapePropType(validate) {
	  var args = {};
	  Object.keys(validate.args).forEach(function (arg) {
	    var element = validate.args[arg];
	    if (element.type && _propTypes2.default[element.type]) {
	      if (element.args) {
	        if (element.type === 'oneOfType') {
	          var elementArgs = getArgs(element.args);
	          args[arg] = _propTypes2.default[element.type](elementArgs);
	        } else if (element.type === 'shape') {
	          args[arg] = buildShapePropType(element);
	        } else {
	          args[arg] = getPropType(element);
	        }
	      } else {
	        args[arg] = _propTypes2.default[element.type];
	      }
	    } else if (element.type) {
	      throw new Error('docPropType: unknown type ' + element.type);
	    }
	  });
	
	  return _propTypes2.default[validate.type](args);
	}
	
	function docPropType(validate, description) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  if (!description) {
	    throw new Error('docPropType: description is required');
	  }
	  if (!validate) {
	    throw new Error('docPropType: validate is required');
	  }
	
	  var required = options.required;
	
	  var type = validate;
	  if (validate.type && _propTypes2.default[validate.type]) {
	    if (validate.args) {
	      if (validate.type === 'oneOfType') {
	        var args = getArgs(validate.args);
	        type = _propTypes2.default[validate.type](args);
	      } else if (validate.type === 'shape') {
	        type = buildShapePropType(validate);
	      } else if (validate.type === 'arrayOf' && validate.args.type === 'oneOfType') {
	        var _args = getArgs(validate.args.args);
	        var v = _extends({}, validate);
	        v.args = _propTypes2.default[validate.args.type](_args);
	        type = getPropType(v);
	      } else {
	        type = getPropType(validate);
	      }
	    } else {
	      type = _propTypes2.default[validate.type];
	    }
	  } else if (validate.type) {
	    throw new Error('docPropType: unknown type ' + validate.type);
	  }
	  // clone function
	  var propType = type.bind(null);
	  if (type.isRequired) {
	    propType.isRequired = type.isRequired.bind(null);
	  }
	  if (required && propType.isRequired) {
	    propType = propType.isRequired;
	  }
	  propType.$$reactDesc = { description: description, validate: validate, options: options };
	  return propType;
	}

/***/ }),

/***/ 46:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDocAsJSON;
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function buildShapeFormat(validate) {
	  var format = {};
	  Object.keys(validate.args).forEach(function (arg) {
	    var element = validate.args[arg];
	    if (element.type === 'shape') {
	      format[arg] = buildShapeFormat(element, true);
	    } else {
	      format[arg] = getFormat(element);
	    }
	  });
	  return format;
	}
	
	function getFormat(validate) {
	  switch (validate.type) {
	    case 'arrayOf':
	      return '[' + validate.args.type + ', ...]';
	    case 'bool':
	      return 'boolean';
	    case 'func':
	      return 'function';
	    case 'instanceOf':
	      return 'new ' + validate.args.name + '(...)';
	    case 'objectOf':
	      return '{ test: ' + validate.args.type + ', ... }';
	    case 'oneOf':
	      return validate.args;
	    case 'oneOfType':
	      return validate.args.map(function (arg) {
	        return getFormat(arg);
	      });
	    case 'shape':
	      return JSON.stringify(buildShapeFormat(validate));
	    default:
	      return validate.type ? validate.type : 'custom';
	  }
	}
	
	function getPropTypeAsJson(propType, propName, defaultValue) {
	  var _propType$$$reactDesc = propType.$$reactDesc.options,
	      deprecated = _propType$$$reactDesc.deprecated,
	      format = _propType$$$reactDesc.format,
	      required = _propType$$$reactDesc.required,
	      extras = _objectWithoutProperties(_propType$$$reactDesc, ['deprecated', 'format', 'required']);
	
	  var validate = propType.$$reactDesc.validate;
	
	  var documentation = {
	    description: propType.$$reactDesc.description,
	    name: propName
	  };
	
	  if (defaultValue) {
	    documentation.defaultValue = defaultValue;
	  }
	
	  if (deprecated) {
	    documentation.deprecated = deprecated;
	  }
	
	  if (required) {
	    documentation.required = required;
	  }
	
	  if (Object.keys(extras).length > 0) {
	    documentation.extras = extras;
	  }
	
	  documentation.format = format || getFormat(validate);
	
	  return documentation;
	}
	
	function getDocAsJSON(component) {
	  if (!component) {
	    throw new Error('getDocAsJSON: component is required');
	  }
	
	  var documentation = {
	    name: component.displayName || component.name
	  };
	  if (component.$$reactDesc) {
	    Object.assign(documentation, component.$$reactDesc);
	
	    if (component.propTypes) {
	      var propTypes = [];
	      Object.keys(component.propTypes).forEach(function (propName) {
	        var propType = component.propTypes[propName];
	        if (propType.$$reactDesc) {
	          propTypes.push(getPropTypeAsJson(propType, propName, (component.defaultProps || {})[propName]));
	        }
	      });
	      if (propTypes.length > 0) {
	        documentation.properties = propTypes;
	      }
	    }
	  }
	  return documentation;
	}

/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDocAsMarkdown;
	
	var _getDocAsJSON = __webpack_require__(46);
	
	var _getDocAsJSON2 = _interopRequireDefault(_getDocAsJSON);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDocAsMarkdown(component) {
	  if (!component) {
	    throw new Error('getDocAsMarkdown: component is required');
	  }
	
	  var documentation = (0, _getDocAsJSON2.default)(component);
	  var description = '';
	  if (documentation.description) {
	    description = '\n' + documentation.description;
	  }
	  var deprecatedNote = '';
	  var deprecatedContent = '';
	  if (documentation.deprecated) {
	    deprecatedNote = '~~';
	    deprecatedContent = '\n### Deprecated: ' + documentation.deprecated;
	  }
	  var properties = '';
	  if (documentation.properties) {
	    properties = '\n\n### Properties\n\n| Property | Description | Format | Default Value | Required | Details |\n| ---- | ---- | ---- | ---- | ---- | ---- |';
	    documentation.properties.forEach(function (prop) {
	      var propDeprecatedNote = '';
	      var propDeprecatedContent = '';
	      if (prop.deprecated) {
	        propDeprecatedNote = '~~';
	        propDeprecatedContent = '**Deprecated**: ' + prop.deprecated;
	      }
	      properties += '\n| **' + propDeprecatedNote + prop.name + propDeprecatedNote + '** | ' + prop.description + ' | ' + prop.format + ' | ' + (prop.defaultValue || '') + ' | ' + (prop.required ? 'Yes' : 'No') + ' | ' + propDeprecatedContent + ' |';
	    });
	  }
	  return '## ' + deprecatedNote + documentation.name + deprecatedNote + ' Component' + deprecatedContent + description + properties;
	}

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docPropType = __webpack_require__(45);
	
	var _docPropType2 = _interopRequireDefault(_docPropType);
	
	var _getDocAsJSON = __webpack_require__(46);
	
	var _getDocAsJSON2 = _interopRequireDefault(_getDocAsJSON);
	
	var _getDocAsMarkdown = __webpack_require__(125);
	
	var _getDocAsMarkdown2 = _interopRequireDefault(_getDocAsMarkdown);
	
	var _PropTypes = __webpack_require__(124);
	
	var _PropTypes2 = _interopRequireDefault(_PropTypes);
	
	var _schema = __webpack_require__(127);
	
	var _schema2 = _interopRequireDefault(_schema);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.docPropType = _docPropType2.default;
	exports.getDocAsJSON = _getDocAsJSON2.default;
	exports.getDocAsMarkdown = _getDocAsMarkdown2.default;
	exports.PropTypes = _PropTypes2.default;
	exports.schema = _schema2.default;
	
	exports.default = {
	  docPropType: _docPropType2.default, getDocAsJSON: _getDocAsJSON2.default, getDocAsMarkdown: _getDocAsMarkdown2.default, PropTypes: _PropTypes2.default, schema: _schema2.default
	};

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = schema;
	
	var _docPropType = __webpack_require__(45);
	
	var _docPropType2 = _interopRequireDefault(_docPropType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function schema(component) {
	  var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (!component) {
	    throw new Error('schema: component is required');
	  }
	  if (!metadata.description) {
	    throw new Error('schema: description is required');
	  }
	
	  var reactDesc = _extends({}, metadata);
	  delete reactDesc.props;
	  var defaultProps = void 0;
	  var propTypes = void 0;
	
	  if (metadata.props) {
	    Object.keys(metadata.props).forEach(function (propName) {
	      var prop = metadata.props[propName];
	      if (!propTypes) {
	        propTypes = {};
	      }
	      // if it is an array it means that it is a react schema instance
	      if (Array.isArray(prop)) {
	        var validate = prop[0];
	        var description = prop[1];
	        var options = prop[2];
	
	        if (options && options.defaultProp) {
	          if (!defaultProps) {
	            defaultProps = {};
	          }
	          defaultProps[propName] = options.defaultProp;
	          delete options.defaultProp;
	        }
	
	        propTypes[propName] = (0, _docPropType2.default)(validate, description, options);
	      } else {
	        propTypes[propName] = prop;
	      }
	    });
	  }
	
	  /* eslint-disable no-param-reassign */
	  component.$$reactDesc = reactDesc;
	  if (propTypes) {
	    component.propTypes = propTypes;
	  }
	
	  if (!component.defaultProps && defaultProps) {
	    component.defaultProps = defaultProps;
	  }
	  /* eslint-enable no-param-reassign */
	}

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(156);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Box = __webpack_require__(7);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _Card = __webpack_require__(328);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Heading = __webpack_require__(41);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _Paragraph = __webpack_require__(159);
	
	var _Paragraph2 = _interopRequireDefault(_Paragraph);
	
	var _Section = __webpack_require__(335);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//import Person from "../img/person.jpg"
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    _Box2.default,
	    { margin: { horizontal: "none", vertical: "large" }, pad: { horizontal: "medium", vertical: "none" } },
	    _react2.default.createElement(
	      _Box2.default,
	      { margin: { horizontal: "none", vertical: "large" }, align: 'center',
	        direction: 'row' },
	      _react2.default.createElement(
	        _Box2.default,
	        { pad: 'medium' },
	        _react2.default.createElement(
	          _Box2.default,
	          { align: 'start' },
	          _react2.default.createElement(
	            _Heading2.default,
	            { tag: 'h1' },
	            _react2.default.createElement(
	              'a',
	              { href: 'https://twitter.com/kainio' },
	              '@kainio'
	            ),
	            ' est un alias virtuel utilis\xE9 comme un canal de publication',
	            _react2.default.createElement('br', null),
	            'par ',
	            _react2.default.createElement(
	              'strong',
	              { 'class': 'real_name', style: { color: "rgb(140, 80, 255)" } },
	              'Soufiane El Kassib'
	            )
	          ),
	          _react2.default.createElement(
	            _Paragraph2.default,
	            { size: 'large' },
	            'kainio est un concepteur, d\xE9veloppeur des solutions pour des probl\xE8mes bien d\xE9finis.'
	          )
	        ),
	        _react2.default.createElement(
	          _Section2.default,
	          { id: 'about' },
	          _react2.default.createElement(
	            _Heading2.default,
	            { tag: 'h2' },
	            '#define Je "kainio"'
	          ),
	          _react2.default.createElement(
	            _Paragraph2.default,
	            null,
	            'Je propose des solutions techniques modernes, en utilisant les m\xE9dias traditionnels comme des canaux de distribution des informations pour atteindre une audience large et vari\xE9e, afin d\'offrir une valeur ajout\xE9e \xE0 la vie sociale, que ce soit par la cr\xE9ation d\u2019une plateforme commercial locale ou d\u2019un syst\xE8me de publication pour les organisations, proposant ainsi des solutions optimales pour des probl\xE8mes bien pos\xE9s.'
	          )
	        ),
	        _react2.default.createElement(
	          _Section2.default,
	          null,
	          _react2.default.createElement(
	            _Heading2.default,
	            { tag: 'h3' },
	            'Technologies et m\xE9thodologie de travail'
	          ),
	          _react2.default.createElement(
	            _Paragraph2.default,
	            null,
	            'Le choix du langage de programmation d\xE9pend des sp\xE9cificit\xE9s de chaque projet, ainsi je peux traiter et distribuer les donn\xE9es suivant plusieurs formats, tout en les manipulant par l\'utilisation des scripts comme le ',
	            _react2.default.createElement(
	              'strong',
	              null,
	              'JavaScript'
	            ),
	            ' et ses variantes, et gr\xE2ce \xE0 des outils et frameworks modernes cot\xE9 front-end, j\'arrive \xE0 bien structurer les donn\xE9es collect\xE9es venant des divers sources et bases de donn\xE9es relationnelles, transmises \xE0 travers des ',
	            _react2.default.createElement(
	              'strong',
	              null,
	              'API'
	            ),
	            ' internes ou externes fournis par une partie tierce, tout cela, suivant une m\xE9thodologie agile o\xF9 les modifications sont fr\xE9quentes lors du processus de d\xE9veloppement.'
	          )
	        ),
	        _react2.default.createElement(
	          _Box2.default,
	          { align: 'start' },
	          _react2.default.createElement(
	            _Heading2.default,
	            { tag: 'h2' },
	            'La conception comme service'
	          ),
	          _react2.default.createElement(
	            _Paragraph2.default,
	            { size: 'large' },
	            'Commerce \xE9lectronique, publication digitale et traditionnelle, et sans oublier un espace de discussion et de partage.'
	          )
	        ),
	        _react2.default.createElement(
	          _Section2.default,
	          null,
	          _react2.default.createElement(
	            _Heading2.default,
	            { tag: 'h3' },
	            'Centres d\'int\xE9r\xEAt'
	          ),
	          _react2.default.createElement(
	            _Paragraph2.default,
	            null,
	            'Je suis int\xE9ress\xE9 par les sujets li\xE9s au d\xE9veloppement web et logiciel ainsi que la conception d\u2019exp\xE9riences utilisateurs destin\xE9es \xE0 une large audience.'
	          )
	        ),
	        _react2.default.createElement(
	          _Section2.default,
	          { id: 'work' },
	          _react2.default.createElement(
	            _Heading2.default,
	            { tag: 'h3' },
	            'Innover dans le domaine commercial et la publication digitales'
	          ),
	          _react2.default.createElement(
	            _Paragraph2.default,
	            null,
	            'Je travaille actuellement sur des solutions concernant le domaine commercial et la publication, dans le but de permettre au commerce local de s\'\xE9tendre sur internet, aux organisations de publier un contenu cibl\xE9 via un site web responsive propuls\xE9 par un syst\xE8me de gestion de contenu, ce dernier sera choisis selon la complexit\xE9 des informations \xE0 traiter, proposant ainsi une solution flexible qui s\'adapte aux besoins de chaque projet.'
	          )
	        ),
	        _react2.default.createElement(
	          _Section2.default,
	          null,
	          _react2.default.createElement(
	            _Box2.default,
	            { align: 'start' },
	            _react2.default.createElement(
	              _Heading2.default,
	              { tag: 'h2' },
	              _react2.default.createElement(
	                'a',
	                { href: 'https://twitter.com/creatima' },
	                '@creatima'
	              ),
	              ' est un guide d\'apprentissage du d\xE9veloppement web avec ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Rails'
	              )
	            ),
	            _react2.default.createElement(
	              _Paragraph2.default,
	              { size: 'large' },
	              'Pour les impatients qui veulent ex\xE9cuter et acc\xE9l\xE9rer le d\xE9veloppement de leur id\xE9e innovante.'
	            )
	          ),
	          _react2.default.createElement(
	            _Heading2.default,
	            { tag: 'h3' },
	            '(Prochainement) Lancement de creatima'
	          ),
	          _react2.default.createElement(
	            _Paragraph2.default,
	            null,
	            'Pour permettre aux utilisateurs de parler entre eux sur divers sujets, je compte publier sur ',
	            _react2.default.createElement(
	              'a',
	              { href: 'http://twitter.com/creatima' },
	              '@creatima'
	            ),
	            ' un guide sur le d\xE9veloppement web avec le framework ruby on rails qui servira comme un r\xE9sum\xE9 de mon parcours d\'apprentissage de cet outil de conception, orient\xE9 vers le d\xE9veloppement des applications web avec le langage ruby, dans le lequel, je cr\xE9erai une documentation d\xE9taill\xE9e en illustrant le processus de cr\xE9ation d\'un prototype, qui servira d\'un MVP (Minimum Viable Product) d\'une application open source de messagerie et va \xEAtre par la suite finalis\xE9e puis d\xE9ploy\xE9e en ligne.'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Box2.default,
	      null,
	      _react2.default.createElement(
	        _Paragraph2.default,
	        null,
	        'Vous pouvez me suivre sur les m\xE9dias sociaux ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://twitter.com/kainio' },
	          'twitter'
	        ),
	        ', ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://github.com/kainio' },
	          'github'
	        ),
	        ' et ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://mastodon.social/@soufiane' },
	          'mastodon'
	        )
	      )
	    )
	  );
	};
	//import App from 'grommet/components/App'
	//import Image from 'grommet/components/Image'
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-9ef43240d9f0b33f122f.js